// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Dashboard V2 — pixel-perfect styles for the GravyWork 2.0 Baseline
 * Calendar tab (Figma node 37530-68068). Every value here is transcribed
 * from Figma Dev Mode (get_design_context) per component, so this file is the
 * single source of truth for the page. Scoped under \`.dashv2\`.
 *
 * Font: Manrope, line-height 1.4, letter-spacing 0. Spacing scale: 4/8/12/16/24.
 */

.dashv2 {
  --green: #44a735;
  --text-green: #2e8722;
  --hl-green: #e7f4e6;
  --stroke-green: #a7daa1;
  --sec-yellow: #eca300;
  --text-yellow: #bb8700;
  --hl-yellow: #fff4d8;
  --stroke-yellow: #ffcc7f;
  --red: #cf040c;
  --hl-red: #ffdfd8;
  --stroke-red: #f86d4f;
  /* Figma \`accent-text/text-deactivated-text\` — the greyed Today control. */
  --deactivated: #979797;
  --blue: #4671ea;
  --blue-bg: #e4f2ff;
  --black: #1c1c1c;
  --subtext: #5b5b5b;
  --stroke-gray: #dadada;
  --hl-gray: #eaeaea;
  --surface: #fcfcfc;
  --white: #ffffff;

  /* Height of the fixed global navbar. Keep in sync with NAVBAR_HEIGHT in
     src/components/AppFrameV2.tsx — the Shift Detail panel docks below it. */
  --navbar-h: 49px;

  font-family: 'Manrope', sans-serif;
  color: var(--black);
  letter-spacing: 0;
  -webkit-font-smoothing: antialiased;
}
.dashv2 * {
  box-sizing: border-box;
}

/* ── Tab bar ─────────────────────────────────────────────── */
.dashv2-tabs {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--stroke-gray);
}
.dashv2-tab {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  /* 48 EXACT, per the frame (\`h-[48px]\`), rather than left to fall out of
     12 + 20 + 12 + a 3px border = 47. \`box-sizing: border-box\` is set for
     \`.dashv2 *\` at the top of this file, so the border sits inside the 48. */
  height: 48px;
  padding: 12px 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--black);
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}
.dashv2-tab svg {
  width: 20px;
  height: 20px;
}
.dashv2-tab.is-active {
  font-weight: 600;
  border-bottom-color: var(--green);
}
.dashv2-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 4px 8px;
  border-radius: 100px;
  background: var(--hl-red);
  color: var(--red);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

/* ── Controls: week-nav (left) + summary (right) ─────────── */
/* Week nav on the left, summary pills + Show on the right.
 *
 * WRAPS rather than overflowing. The two groups are sized by their content —
 * nav 321px, summary 441px — and neither can shrink, because every label inside
 * them is \`nowrap\`. Below ~762px of content width they therefore did not merely
 * crowd: the summary ran straight past the container. At a 1024px viewport the
 * app shell leaves 704px, so the Show button ended at x=1050, 58px beyond the
 * page and outside the viewport entirely.
 *
 * Wrapping keeps every element at the size the design gives it and moves the
 * whole right-hand group to its own line only when there is genuinely no room —
 * so at the widths this was drawn for the layout is pixel-identical, and nothing
 * is ever hidden or clipped. \`margin-left: auto\` keeps that group right-aligned
 * whether it shares the line or not (\`space-between\` alone would flush it left
 * once it is the only item on the second line). */
.dashv2-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 12px;
  padding: 8px 0;
}
.dashv2-weeknav {
  display: flex;
  align-items: center;
  gap: 16px;
}
.dashv2-nav-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
.dashv2-iconbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  background: var(--white);
  cursor: pointer;
  color: var(--black);
  padding: 0;
}
.dashv2-iconbtn svg {
  width: 20px;
  height: 20px;
}
.dashv2-range {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
.dashv2-today-btn {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--surface);
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}

.dashv2-summary {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.dashv2-summary-pills {
  display: flex;
  align-items: center;
  gap: 12px;
}
/* Each pill is a BUTTON — the Calendar's fill-rate quick filter (GRAVY-10319),
   not a read-only count. Geometry and colour are unchanged from what shipped;
   what is new is the interactive state, transcribed from the approved prototype
   (\`ui-prototype/shift-risk-monitoring\`, \`.risk-badge\`): the same hue at 0.5
   alpha instead of 0.24, a coloured hover ring, and a separator + X revealed on
   the active chip. */
.dashv2-summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  transition: box-shadow 0.12s, background 0.12s;
}
.dashv2-summary-pill svg {
  width: 20px;
  height: 20px;
}
.dashv2-summary-pill.is-critical {
  background: rgba(255, 223, 216, 0.24);
  color: var(--red);
  border-color: var(--stroke-red);
}
.dashv2-summary-pill.is-critical:hover {
  box-shadow: 0 0 0 3px rgba(207, 4, 12, 0.1);
}
.dashv2-summary-pill.is-critical.is-active {
  background: rgba(255, 223, 216, 0.5);
}
.dashv2-summary-pill.is-atrisk {
  background: rgba(255, 244, 216, 0.24);
  color: var(--text-yellow);
  border-color: var(--stroke-yellow);
}
.dashv2-summary-pill.is-atrisk:hover {
  box-shadow: 0 0 0 3px rgba(236, 163, 0, 0.1);
}
.dashv2-summary-pill.is-atrisk.is-active {
  background: rgba(255, 244, 216, 0.5);
}
.dashv2-summary-pill.is-filled {
  background: rgba(231, 244, 230, 0.24);
  color: var(--text-green);
  border-color: var(--stroke-green);
}
.dashv2-summary-pill.is-filled:hover {
  box-shadow: 0 0 0 3px rgba(68, 167, 53, 0.12);
}
/* The one band whose BORDER also changes when active, per the prototype. */
.dashv2-summary-pill.is-filled.is-active {
  background: rgba(231, 244, 230, 0.5);
  border-color: var(--green);
}
.dashv2-summary-pill:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
/* Only on the active chip — it says the next click clears the filter. Both are
   decorative; the button itself is the control. */
.dashv2-pill-sep {
  width: 0;
  height: 16px;
  /* On top of the 8px flex gap, per the prototype. */
  margin-left: 4px;
  border-left: 1px solid;
}
/* The separator takes the band's STROKE colour, not the label's — the two differ
   in all three bands. The X takes the label colour, so it inherits. */
.dashv2-summary-pill.is-critical .dashv2-pill-sep {
  border-color: var(--stroke-red);
}
.dashv2-summary-pill.is-atrisk .dashv2-pill-sep {
  border-color: var(--stroke-yellow);
}
.dashv2-summary-pill.is-filled .dashv2-pill-sep {
  border-color: var(--green);
}
.dashv2-pill-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.dashv2-pill-x svg {
  width: 16px;
  height: 16px;
}
.dashv2-showbtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-showbtn svg {
  width: 20px;
  height: 20px;
}

/* ── Calendar filter bar (Figma 37673:100905, GRAVY-10305) ─ */
/* Row is 44px tall and full width: two bordered icon-anchored groups 24px
   apart on the left, Reset filters pinned right. */
.dashv2-fbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 4px 0 12px;
  flex-wrap: wrap;
}
.dashv2-fbar-groups {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}
.dashv2-fgroup {
  display: flex;
  align-items: stretch;
  height: 44px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
}
/* The icon cell: 20px glyph, its own padding, divided from the first segment
   by that segment's left border. */
.dashv2-fgroup-icon {
  display: inline-flex;
  align-items: center;
  /* 36px cell (8px + 20px glyph + 8px) in the funnel group. */
  padding: 0 8px;
  color: var(--black);
}
/* The eye group's cell is 44px in the design: 12px + 20px glyph + 12px. */
.dashv2-fgroup + .dashv2-fgroup .dashv2-fgroup-icon {
  padding: 0 12px;
}
.dashv2-fgroup-icon svg {
  width: 20px;
  height: 20px;
}
/* Segments are separated by 1px dividers; the group's own border supplies the
   outer edges, so only the left divider is drawn per segment. */
.dashv2-fseg {
  position: relative;
  display: flex;
  align-items: stretch;
  border-left: 1px solid var(--stroke-gray);
  /* Eye-group cells are 120px in the design, funnel-group cells 160px. The
     divider is part of that width, so it is set here rather than on the button
     — otherwise each segment renders 1px wide and the groups drift off the
     design by 3px each. */
  min-width: 120px;
}
.dashv2-fgroup:first-child .dashv2-fseg {
  min-width: 160px;
}
.dashv2-fseg-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 100%;
  padding: 10px 4px 10px 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  /* Funnel-group cells are PLACEHOLDERS ("Client") and render grey until a
     selection is applied. */
  color: var(--subtext);
}
/* Eye-group cells are not placeholders — "All status" is a real default state,
   so the design renders them black from the start. */
.dashv2-fgroup + .dashv2-fgroup .dashv2-fseg-btn {
  color: var(--black);
}
.dashv2-fseg-btn.is-active {
  color: var(--black);
  font-weight: 600;
}
.dashv2-fseg-btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.dashv2-fseg-btn:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: -2px;
  border-radius: 8px;
}
.dashv2-fseg-btn svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--black);
}
.dashv2-fseg-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Each segment opens its OWN scoped list, rather than all dimensions sharing
   one long menu. Capped so a tenant with hundreds of clients scrolls inside
   the menu instead of covering the calendar. */
.dashv2-fseg-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: -1px;
  z-index: 20;
  min-width: 220px;
  max-width: 320px;
  background: var(--white);
  border: 1px solid var(--stroke-gray);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.dashv2-fseg-menu.align-right {
  left: auto;
  right: -1px;
}
.dashv2-fseg-options {
  max-height: 260px;
  overflow-y: auto;
  padding: 8px 0;
}
.dashv2-fseg-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--black);
  cursor: pointer;
}
.dashv2-fseg-option:hover {
  background: var(--surface);
}
.dashv2-fseg-option:focus-within {
  outline: 2px solid var(--blue);
  outline-offset: -2px;
}
.dashv2-fseg-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid var(--stroke-gray);
}
.dashv2-fseg-clear,
.dashv2-fseg-apply {
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--stroke-gray);
  background: var(--white);
  color: var(--black);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.dashv2-fseg-apply {
  border-color: var(--green);
  background: var(--green);
  color: var(--white);
}
.dashv2-fseg-clear:disabled {
  color: var(--subtext);
  opacity: 0.5;
  cursor: default;
}
.dashv2-fseg-clear:focus-visible,
.dashv2-fseg-apply:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}

.dashv2-freset {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-freset svg {
  width: 20px;
  height: 20px;
}
/* Greyed with nothing applied, matching the design's default state. */
.dashv2-freset:disabled {
  color: var(--subtext);
  cursor: default;
}
.dashv2-freset:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}

/* ── Calendar grid ───────────────────────────────────────── */
.dashv2-calendar {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.dashv2-daycol {
  min-width: 0;
}
.dashv2-daycol.is-today {
  background: rgba(231, 244, 230, 0.5);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* Day header */
.dashv2-dayhead {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 8px;
  border-bottom: 1px solid var(--stroke-gray);
}
.dashv2-daycol.is-today .dashv2-dayhead {
  border-bottom: 3px solid var(--green);
}
.dashv2-dayhead-top {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.dashv2-weekday {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-daycol.is-today .dashv2-weekday {
  font-weight: 600;
}
.dashv2-fillpct {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-fillpct.band-high {
  background: var(--hl-green);
  color: var(--text-green);
}
.dashv2-fillpct.band-mid {
  background: var(--hl-yellow);
  color: var(--text-yellow);
}
.dashv2-fillpct.band-low {
  background: var(--hl-red);
  color: var(--red);
}
.dashv2-fillpct.band-none {
  background: var(--hl-gray);
  color: var(--subtext);
}
.dashv2-daynum {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-daycol.is-today .dashv2-daynum {
  background: var(--green);
  color: var(--white);
  font-weight: 800;
}

/* Shift list */
.dashv2-shiftlist {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 4px;
}

/* ── Shift card ──────────────────────────────────────────── */
.dashv2-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--surface);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  /* Reset for when the card renders as a <button> (opens the detail panel). */
  width: 100%;
  text-align: left;
  font-family: inherit;
  appearance: none;
  /* Lets the status row respond to the card's own width rather than the
     viewport's, so deep browser zoom and narrow windows behave identically
     (the seven calendar columns are minmax(0, 1fr), so a card can get very
     narrow at any viewport size). */
  container-type: inline-size;
}

/* The card is the keyboard target when it renders as a <button>; make that
   visible rather than relying on the UA default. */
.dashv2-card:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
.dashv2-card.level-warn {
  background: rgba(255, 244, 216, 0.32);
  border-color: var(--stroke-yellow);
}
.dashv2-card.level-critical {
  background: #fff4f2;
  border-color: var(--stroke-red);
}

.dashv2-quickinfo {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
/* Dependability, the status ribbon and the lock can all apply at once. The row
   must wrap onto extra lines instead of running past the card edge, where the
   card's \`overflow: hidden\` would clip a badge into an unreadable fragment.
   12px both ways, per Figma (node 38730:44565 lays the pills out at 12px
   between siblings and 12px between rows). Wrapping is what prevents the
   clipping, so the gap does not need to be shaved to buy room. */
.dashv2-card-toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  max-width: 100%;
}
.dashv2-lock {
  display: inline-flex;
  flex: none;
  width: 20px;
  height: 20px;
  color: var(--black);
}

/* Status ribbons — all 12px SemiBold, rounded 8, no icon except Dependability */
.dashv2-ribbon {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  /* Flex items default to min-width: auto, which refuses to shrink below
     min-content and pushes the row past the card. Allow the shrink and let the
     label ellipsize instead — a truncated label still reads, a clipped badge
     does not. */
  min-width: 0;
}
/* The glyph carries the meaning when space is tight, so it never shrinks. */
.dashv2-ribbon svg {
  flex: none;
}
.dashv2-ribbon-label {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashv2-ribbon.type-dependability {
  gap: 2px;
  padding: 2px 8px 2px 4px;
  background: transparent;
  border: 1px solid var(--stroke-red);
  color: var(--red);
}
.dashv2-ribbon.type-dependability svg {
  width: 20px;
  height: 20px;
}
.dashv2-ribbon.type-starts_in {
  background: var(--red);
  color: var(--white);
}
.dashv2-ribbon.type-in_progress {
  background: var(--blue-bg);
  color: var(--blue);
}
.dashv2-ribbon.type-needs_approval {
  background: var(--hl-yellow);
  color: var(--text-yellow);
}

/* Last-resort fallback for a genuinely tiny card (deep browser zoom, or a
   narrow window divided across seven columns): drop to the arrow glyph alone
   and keep the label as the pill's accessible name, so the state is never
   lost.

   The threshold is measured against the card's CONTENT box, not its border
   box — that is what a size container query resolves against. The card is
   12px-padded with a 1px border, so its content box runs 26px narrower than
   the column: a 152px card at a 1440px viewport queries as 126px.

   The full "Dependability" pill measures 111px (Figma has it at 114px), so the
   label fits on a row of its own down to ~111px of content width. An earlier
   threshold of 150px therefore hid it at every realistic desktop width —
   1600px viewport included — leaving a bare red arrow where the design shows
   the labelled pill. 100px keeps the fallback for the case it was written for
   and nothing else.

   This rule is a legibility nicety, not the anti-clipping mechanism: wrapping
   plus \`min-width: 0\` and the ellipsizing label already hold every indicator
   inside the card on their own, at every width down to ~75px.

   Progressive enhancement: where @container is unsupported the label simply
   ellipsizes via .dashv2-ribbon-label instead — degraded, but still not
   clipped. */
@container (max-width: 100px) {
  .dashv2-ribbon.type-dependability {
    padding: 2px 4px;
  }
  .dashv2-ribbon.type-dependability .dashv2-ribbon-label {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    overflow: hidden;
    clip-path: inset(50%);
  }
}

.dashv2-card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.dashv2-card-title {
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  margin: 0;
  color: var(--black);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.dashv2-card-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.dashv2-card-meta p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashv2-card-time {
  font-weight: 600;
  color: var(--black);
  white-space: nowrap;
}
/* A card narrower than its own time range lets the END time fall off the edge:
   "5:00PM-9:00PM" needs ~109px, and seven day columns in the 704px a 1024px
   viewport leaves gives each card ~91. Ellipsis is the right answer for an
   identity (the title has a \`title\` attribute and the client is recognisable
   from its start), but a shift you cannot see the end of is missing the thing
   the card exists to tell you.

   So below the width where it fits, the range wraps after its hyphen instead —
   two short lines, nothing lost. Scoped with the same \`@container\` the ribbon
   rule uses, so it keys off the CARD rather than the viewport and stays correct
   however the grid is sized. */
@container (max-width: 118px) {
  .dashv2-card-time {
    white-space: normal;
  }
}
.dashv2-card-role {
  font-weight: 400;
  color: var(--black);
}
.dashv2-card-loc {
  font-weight: 400;
  color: var(--subtext);
}

.dashv2-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.dashv2-hired {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-hired.status-filled {
  background: var(--green);
  color: var(--white);
}
.dashv2-hired.status-at_risk {
  background: var(--sec-yellow);
  color: var(--white);
}
.dashv2-hired.status-critical {
  background: var(--hl-red);
  color: var(--red);
}
.dashv2-chevron {
  display: inline-flex;
  width: 24px;
  height: 24px;
  color: var(--black);
}

/* Empty day */
.dashv2-empty {
  padding: 24px 8px;
  color: var(--subtext);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}

/* ── Queue tabs: title row ───────────────────────────────── */
.dashv2-queue-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
.dashv2-queue-heading {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}
.dashv2-queue-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 16px;
}
.dashv2-queue-empty {
  padding: 48px 24px;
  text-align: center;
  color: var(--subtext);
  font-size: 14px;
  line-height: 1.4;
}

/* ── Missing-timesheet row actions (GRAVY-10307 / 10318) ──────────────────
   Both row actions are now ICONS in their own grid tracks. The text button they
   replaced ("Enter hours", plus the phone number rendered as a link) was wide
   enough to squeeze Check-in/Check-out/Break/Total into each other, which is
   the defect GRAVY-10318 fixes — so the geometry here is load-bearing, not
   decoration. Call reuses \`.dashv2-nscall\` from the No Show card: same action,
   same affordance. */
.dashv2-tsedit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
}
.dashv2-tsedit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 100px;
  background: transparent;
  color: var(--green);
  cursor: pointer;
}
.dashv2-tsedit-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.7);
}
.dashv2-tsedit-btn svg {
  width: 20px;
  height: 20px;
}
.dashv2-tsedit-btn:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
.dashv2-tsedit-btn:disabled {
  color: var(--subtext);
  opacity: 0.5;
  cursor: default;
}

/* ── Enter Hours dialog (GRAVY-10307) ─────────────────────── */
.dashv2-ehoverlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
}
.dashv2-ehdialog {
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  border-radius: 12px;
  background: var(--white);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}
.dashv2-ehtitle {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-ehcontext {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin: 0 0 20px;
  padding: 12px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--surface);
}
.dashv2-ehcontext > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.dashv2-ehcontext dt {
  font-size: 13px;
  color: var(--subtext);
}
.dashv2-ehcontext dd {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}
.dashv2-ehfields {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.dashv2-ehfield {
  display: flex;
  flex: 1 1 120px;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: var(--subtext);
}
.dashv2-ehfield input,
.dashv2-ehfield select {
  height: 40px;
  padding: 0 10px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  color: var(--black);
  font-family: inherit;
  font-size: 14px;
}
.dashv2-eherror {
  margin: 12px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--red);
}
.dashv2-ehfoot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}
.dashv2-ehcancel,
.dashv2-ehsave,
.dashv2-ehresolve {
  height: 36px;
  padding: 0 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  color: var(--black);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.dashv2-ehresolve {
  border-color: var(--green);
  background: var(--green);
  color: var(--white);
}
.dashv2-ehcancel:disabled,
.dashv2-ehsave:disabled,
.dashv2-ehresolve:disabled {
  opacity: 0.6;
  cursor: default;
}
.dashv2-ehcancel:focus-visible,
.dashv2-ehsave:focus-visible,
.dashv2-ehresolve:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}

/* ── Queue pagination (GRAVY-10304) ──────────────────────── */
.dashv2-qpage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 4px 0;
  flex-wrap: wrap;
}
.dashv2-qpage-range {
  font-size: 13px;
  color: var(--subtext);
}
.dashv2-qpage-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashv2-qpage-count {
  font-size: 13px;
  font-weight: 600;
  color: var(--black);
  min-width: 96px;
  text-align: center;
}
.dashv2-qpage-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  color: var(--black);
  cursor: pointer;
}
.dashv2-qpage-btn svg {
  width: 16px;
  height: 16px;
}
.dashv2-qpage-btn:hover:not(:disabled) {
  background: var(--hl-gray);
}
.dashv2-qpage-btn:disabled {
  color: var(--subtext);
  opacity: 0.5;
  cursor: default;
}
.dashv2-qpage-btn:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}

.dashv2-retrybtn {
  margin-top: 12px;
  padding: 6px 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 6px;
  background: var(--white);
  color: var(--black);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.dashv2-retrybtn:hover {
  background: var(--hl-gray);
}

/* ── No-show card ────────────────────────────────────────── */
.dashv2-nscard {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
}
.dashv2-nshead {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}
.dashv2-nscol {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  padding-right: 24px;
  min-width: 0;
  /* The labels are nowrap, so a column squeezed by a full header row would
     otherwise spill its text sideways underneath the adjacent controls rather
     than clipping inside its own box. */
  overflow: hidden;
}
.dashv2-nscol--client {
  flex: 0 1 432px;
}
.dashv2-nscol--date {
  flex: 0 0 220px;
}
.dashv2-nscol--skill {
  flex: 0 0 200px;
}
/* A real basis, not 0: with basis 0 this column takes only *surplus* space, so
   on a full header row (the missing-timesheet card carries a "Shift details"
   button as well as the chevron) it collapsed to zero width and its label
   overflowed. Shrinking now comes out of the wide client column instead. */
.dashv2-nscol--loc {
  flex: 1 1 140px;
}
.dashv2-nslabel {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
  margin: 0;
  white-space: nowrap;
}
.dashv2-nsvalue {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.dashv2-nsexpand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: var(--black);
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.dashv2-nsexpand svg {
  width: 24px;
  height: 24px;
}
/* NOTE: \`.dashv2-nsdetail\` — the outlined "Shift details" text button — is gone.
   It existed only because the Missing Timesheet chevron was spent on collapsing
   the card's own rows, so the drill-in needed a second, unmistakably different
   control (GRAVY-10297). GRAVY-10318 removed that collapse, freeing the chevron
   to be the drill-in itself, exactly as No Show and Needs Approval already do. */

.dashv2-nsexpand:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}
/* Only when the row has no shift to open (a job with no shift rows), so the
   control reads as unavailable rather than silently doing nothing. */
.dashv2-nsexpand:disabled {
  color: var(--subtext);
  opacity: 0.4;
  cursor: default;
}

/* A grid header and its worker rows must share ONE content box, or the tracks
   are the same widths at different origins and every column is off by a
   constant. The rows carry \`padding: 16px\` — the inset that makes the pink block
   read as a block — and the header carried none, so both cards' columns sat
   exactly 16px left of the fields beneath them (GRAVY-10317 / 10318).

   Horizontal only: the header's vertical spacing is the card's, not the row's. */
.dashv2-nshead.dashv2-nsgrid,
.dashv2-nshead.dashv2-tsgrid {
  padding: 0 16px;
}

/* Worker rows */
.dashv2-nsworkers {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.dashv2-nsrow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  width: 100%;
  background: rgba(252, 233, 230, 0.5);
}
.dashv2-nsrow:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.dashv2-nsrow:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.dashv2-nsuser {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 363px;
  min-width: 0;
}
.dashv2-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--hl-gray);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: var(--subtext);
}
.dashv2-avatar img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dashv2-nsname {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashv2-nsfield {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  padding-right: 16px;
}
/* 120px fitted "No show" exactly. The unresolved states carry longer labels
   ("Awaiting confirmation"), which wrapped inside a fixed-height 24px pill and
   spilled out of it (GRAVY-10302). Sized to the longest label instead. */
.dashv2-nsfield--status {
  flex: 0 0 190px;
}
.dashv2-nsfield--grow {
  flex: 1 1 0;
}
.dashv2-nsbadge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #c10000;
  color: #fff4f3;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  width: fit-content;
  margin-top: 4px;
  /* The pill is a fixed 24px tall, so it must never wrap — a wrapped label
     renders outside its own background. */
  white-space: nowrap;
  /* …but \`nowrap\` + \`fit-content\` also means it does not shrink, and a grid
     track does. At a 1024px viewport "Awaiting confirmation" rendered 163px
     wide in a 118px cell and painted 25px OVER the "Marked by" column beside
     it. This is the hard guarantee that it can never leave its own cell,
     whatever the width; the media query below is what stops it needing to. */
  max-width: 100%;
  overflow: hidden;
}
/* Only a CONFIRMED absence keeps the solid red treatment. Unresolved
   attendance alerts are risk, not fact, so they read as amber warnings — the
   colour has to carry the same distinction the label does (GRAVY-10302). */
.dashv2-nsbadge.state-awaiting_confirmation,
.dashv2-nsbadge.state-backfill_requested,
.dashv2-nsbadge.state-escalated {
  background: var(--hl-yellow);
  color: var(--text-yellow);
}
.dashv2-nsfield-val {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Missing-timesheet worker row (reuses no-show card + rows) ────────── */
/* ── No Show: ONE shared column grid (GRAVY-10317) ───────── */
/* The header and the worker rows used to size themselves independently — the
   header on flex bases 432/220/200/140, the rows on 363/190/grow — so Status,
   Marked by and the timestamp did not sit under the headings they belong to.
   Both now use this single definition, which makes the alignment structural
   instead of two sets of numbers kept in step by hand.

   Scoped to the No Show card rather than applied to \`.dashv2-nshead\`, which
   Missing Timesheet also uses — but its rows are finer-grained than its header
   (four timesheet columns under two headings), so it needs its own track list
   and spanning header cells. See \`.dashv2-tsgrid\`.

   Declared AFTER \`.dashv2-nshead\` / \`.dashv2-nsrow\` so \`display: grid\` wins over
   their \`display: flex\` at equal specificity. \`flex\` on the children is inert
   inside a grid, so those rules need no unpicking — only the manual
   \`padding-right\`, which \`gap\` replaces. */
.dashv2-nsgrid {
  display: grid;
  grid-template-columns:
    minmax(0, 2.1fr) minmax(0, 1.25fr) minmax(0, 1.15fr)
    minmax(0, 1fr) 40px;
  align-items: center;
  gap: 20px;
  width: 100%;
}
.dashv2-nsgrid .dashv2-nscol,
.dashv2-nsgrid .dashv2-nsfield,
.dashv2-nsgrid .dashv2-nsuser {
  padding-right: 0;
  min-width: 0;
}

/* The drill-in. Right-facing and STAYS right-facing: it opens the shift, it
   does not expand anything (the rows are always shown). */
.dashv2-nsdrill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--subtext);
  cursor: pointer;
}
.dashv2-nsdrill:hover {
  background: var(--surface);
  color: var(--black);
}
.dashv2-nsdrill svg {
  width: 20px;
  height: 20px;
}
.dashv2-nsdrill:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
.dashv2-nsdrill:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Call the worker. Same affordance as the Missing Timesheet contact link; the
   cell is always present so a worker with no authorized number cannot pull the
   other columns out of alignment. */
.dashv2-nsaction {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
}
.dashv2-nsprofile,
.dashv2-nscall {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  color: var(--green);
}
.dashv2-nscall:hover {
  background: rgba(255, 255, 255, 0.7);
}
.dashv2-nsprofile svg,
.dashv2-nscall svg {
  width: 20px;
  height: 20px;
}
.dashv2-nscall:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}

/* ── Missing Timesheet: ONE shared column grid (GRAVY-10318) ─────────────
   The header sized itself on the flex bases 432/220/200/140 and the rows on
   363/160/four-equal-columns plus a \`margin-left: auto\` action group, so the
   timesheet columns did not sit under the headings above them and, squeezed,
   ran into each other.

   The worker row is FINER-GRAINED than the header — Skill heads two time
   columns, Location heads two more — so the tracks below are the row's, and the
   header cells span them. That is why this cannot be \`.dashv2-nsgrid\`: No Show's
   header maps one-to-one onto its rows.

   Declared AFTER \`.dashv2-nshead\` / \`.dashv2-nsrow\` so \`display: grid\` wins over
   their \`display: flex\` at equal specificity. The children's \`flex\` rules are
   inert inside a grid, so they need no unpicking — only the manual
   \`padding-right\`, which \`gap\` replaces.

   The time tracks have REAL minimums (not \`minmax(0, …)\`): their labels are
   \`nowrap\`, so a track allowed to collapse below its label width is exactly how
   "Check-in" and "Check-out" merged. The minimums are sized to the longest
   label in each. */
.dashv2-tsgrid {
  display: grid;
  grid-template-columns:
    minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(76px, 0.7fr) minmax(76px, 0.7fr)
    minmax(56px, 0.5fr) minmax(56px, 0.5fr) 40px 40px;
  align-items: center;
  gap: 16px;
  width: 100%;
}
.dashv2-tsgrid .dashv2-nscol,
.dashv2-tsgrid .dashv2-nsfield,
.dashv2-tsgrid .dashv2-nsuser,
.dashv2-tsgrid .dashv2-tscol {
  padding-right: 0;
  min-width: 0;
}
/* The header's four cells over the row's eight tracks. Placed explicitly rather
   than left to auto-placement, so a spanning cell cannot shunt the ones after
   it. */
.dashv2-tsgrid > .dashv2-nscol--date {
  grid-column: 1;
}
.dashv2-tsgrid > .dashv2-nscol--client {
  grid-column: 2;
}
.dashv2-tsgrid > .dashv2-nscol--skill {
  grid-column: 3 / span 2;
}
.dashv2-tsgrid > .dashv2-nscol--loc {
  grid-column: 5 / span 2;
}
/* Over the two row actions, hard right — the same place the call icon sits, so
   the card has one action rail rather than two. */
.dashv2-tsgrid > .dashv2-nsdrill {
  grid-column: 7 / span 2;
  justify-self: end;
}
.dashv2-tscol {
  display: flex;
  flex-direction: column;
  min-width: 0;
  align-items: flex-start;
}
.dashv2-tscol .dashv2-nslabel {
  white-space: nowrap;
}
.dashv2-tscol-val {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--red);
  margin: 0;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.dashv2-tscol-val.has-data {
  color: var(--black);
}

/* ── Queue cards below the width they were drawn for ─────────────────────
 *
 * The card grids are proportional (\`fr\`), so on a narrow window every track
 * shrinks together — and the COLUMN LABELS are \`nowrap\`, so past a point they
 * clip instead. At a 1024px viewport the app shell leaves 704px, which gives No
 * Show's fourth track ~100px while "Date & time marked" needs 125: the heading
 * for a column becomes unreadable, which is worse than any value being
 * ellipsised, because a value carries a \`title\` and a label does not.
 *
 * Below 1280px the labels are allowed to WRAP. Nothing moves, nothing is hidden,
 * and no track has to grow — a two-line heading simply takes the height it
 * needs. \`nowrap\` stays in force at the widths the design was transcribed from,
 * where it is doing its real job: stopping a squeezed label spilling sideways
 * underneath the control beside it.
 *
 * The values keep ellipsising as before; \`.dashv2-nsvalue\` and
 * \`.dashv2-nsfield-val\` already carry \`text-overflow\` and a \`title\`. */
/* ── ≤1439: the narrow-width design ──────────────────────── */
/* Figma \`Admin-Dashboard x 1024\` (GravyWork 2.0 Baseline, 39124:32563) is the
   spec for 1439px and below; what shipped is the 1440+ layout. Its variable
   modes say so explicitly — \`screen/screen-width: 1024\`, \`show-hide/hamburger
   menu: true\` — so this is a designed breakpoint, not a one-off artboard.
   Full extract: gravy-docs \`dashboard-v2/docs/figma-1024-breakpoint-spec.md\`.

   The design's answer to the squeeze is to DROP LABELS TO ICONS rather than
   shrink type, which is what the earlier 1279 layer below does. Measured from
   the frame:

     Calendar tab   125px = 16 + 20 + 12 + 61(label) + 16   (keeps its label)
     queue tabs      84px = 16 + 20 + 12 + 20(badge) + 16   (icon + badge only)
     summary pill    44px = 12 + 20 + 12                    (icon only)
     filter toggle   36px square                            (icon only)

   Hidden VISUALLY, never \`display: none\`: these are the accessible names of the
   controls, and a tab that announces only "12" is worse than a cramped one. */
@media (max-width: 1439px) {
  /* The ACTIVE tab always shows its name (GRAVY-10332). Compacting every tab
     left the green underline as the only cue to which queue you were in, which
     at the narrowest supported width is where you can least afford to guess.
     Inactive queue tabs stay icon + badge, so only one label is expanded. */
  .dashv2-tab:not(.is-labelled):not(.is-active) .dashv2-tab-label,
  .dashv2-pill-text,
  .dashv2-showbtn-label {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }

  /* Anchor the hidden span to its own button rather than to whatever ancestor
     happens to be positioned. */
  .dashv2-tab,
  .dashv2-summary-pill,
  .dashv2-showbtn--compact {
    position: relative;
  }

  /* An absolutely-positioned child is out of flex flow, so \`gap\` no longer has
     two items to sit between and the padding alone sets the width. The active
     chip's separator and X have no room beside a bare icon — the fill and
     border already carry the pressed state. */
  .dashv2-summary-pill .dashv2-pill-sep,
  .dashv2-summary-pill .dashv2-pill-x {
    display: none;
  }
  /* 36 SQUARE. Height matters as much as width and was missed first time
     round: the base rule is 32px tall, so setting only the width left a 36×32
     control against the frame's 36×36. */
  /* Scoped to \`--compact\` — the Calendar's control, the only one the frame
     draws as a 36px square (GRAVY-10332).
     
     This rule was unscoped, so it also hit the action queues' Show/Hide button,
     whose label is NOT wrapped for hiding — a 36px box around the word "Show",
     which read as a broken control. A width can only be forced onto a button
     whose text can get out of the way. */
  .dashv2-showbtn--compact {
    padding: 0;
    width: 36px;
    height: 36px;
    justify-content: center;
  }

  /* Pin the two icon-only controls to the frame's own numbers. Both need an
     explicit width: the boxes are auto-sized from padding, so the 1px border
     lands OUTSIDE the 44 the design specifies (Figma strokes are centred and
     do not grow an auto-layout frame). With \`box-sizing: border-box\` set at the
     top of this file, a stated width absorbs it. */
  .dashv2-summary-pill {
    width: 44px;
    /* The frame's pills are \`h-full\` inside a 36px control row — the same
       height as the funnel beside them, so the row reads as one band. */
    height: 36px;
    justify-content: center;
  }
  /* 84px tab = 16 + 20 + 12 + 20 + 16. The badge is 20/11px at this width,
     against 24/12px at 1440+.
     
     The frame draws the badge as a fixed \`size-[20px]\` circle. Ours keeps
     \`min-width\` instead so a three-digit count grows rather than clipping — a
     count badge that hides its own digits is worse than one pixel of drift.
     The horizontal padding is 2px so that for one- and two-digit counts the
     min-width still wins under any font and the tab lands on exactly 84: with
     4px it did not, because Manrope's digits are wider than the fallback this
     was first measured against, and "55" pushed the badge to 21px. */
  .dashv2-tab-badge {
    min-width: 20px;
    height: 20px;
    padding: 4px 2px;
    font-size: 11px;
  }
  /* The active-filter count is not a label — it is the only thing saying a
     collapsed bar still has filters in force, so it survives the collapse and
     sits on the icon. */
  .dashv2-showbtn--compact .dashv2-qfcount {
    position: absolute;
    top: -6px;
    right: -6px;
  }
}

@media (max-width: 1279px) {
  /* The No Show status pill carries the longest label on the card
     ("Awaiting confirmation"). Give its track a real minimum — the same remedy
     GRAVY-10318 used for the timesheet columns — and take the pill down to the
     12px the prototype's own compact treatment uses, so it FITS rather than
     being clipped by the rule above. A tighter gap pays for the minimum. */
  .dashv2-nsgrid {
    grid-template-columns:
      minmax(0, 1.9fr) minmax(140px, 1.35fr) minmax(0, 1.1fr) minmax(0, 1fr)
      40px;
    gap: 12px;
  }
  .dashv2-nsbadge {
    font-size: 12px;
    padding: 2px 6px;
  }

  /* \`.dashv2-nscol\` carries a legacy \`padding-right: 24px\` from when these were
     flex columns. \`.dashv2-nsgrid\`/\`.dashv2-tsgrid\` reset it — \`gap\` does that
     job now — but the Needs Approval row is still a flex row, so it kept it. On
     a 65px column that leaves 41px of content, which is why "Location" broke
     mid-word into "Locati / on" once wrapping was allowed. The row's own \`gap\`
     already provides the separation. */
  .dashv2-narow .dashv2-nscol {
    padding-right: 0;
  }

  .dashv2-nslabel {
    white-space: normal;
    /* \`normal\` alone is not enough: a single long word has no break
       opportunity, so "Location" still overflowed and clipped to "Loc".
       \`break-word\` rather than \`anywhere\` — it breaks a word only when it
       would otherwise overflow, and leaves min-content sizing alone. */
    overflow-wrap: break-word;
  }
  /* The Missing Timesheet card is the densest thing on the page — eight tracks,
     four of them with real minimums sized to their \`nowrap\` labels
     (GRAVY-10318). Those minimums plus the gaps consume 456 of the 672px a
     1024px viewport leaves, so the worker's NAME was squeezed to 39px: unusable,
     and the one column an admin actually reads.

     Letting these labels wrap too releases their floors, and a tighter gap
     releases more. Nothing is hidden and no column is dropped — the grid simply
     stops reserving width for text that is allowed to take a second line. Above
     1280px none of this applies and the card is exactly as transcribed. */
  .dashv2-tsgrid {
    grid-template-columns:
      minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(52px, 0.7fr) minmax(52px, 0.7fr)
      minmax(44px, 0.5fr) minmax(44px, 0.5fr) 36px 36px;
    gap: 10px;
  }
  .dashv2-tsedit,
  .dashv2-tsedit-btn,
  .dashv2-nsaction,
  .dashv2-nscall {
    width: 36px;
  }
}

/* ── Needs-approval row (single row per shift, reuses card container) ─── */
.dashv2-narow {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}
/* \`0 1\`, not \`0 0\`. The basis is still the designed width, so nothing moves at
   the widths this row was drawn for — but the columns may now give ground when
   there is less room than they want. With \`0 0\` they could not: 220 + 330 + 200
   plus gaps and the chevron needs ~920px, and a 1024px viewport leaves the
   dashboard 670, so the row overflowed its own card by 252px. \`min-width: 0\` is
   what actually lets a flex item shrink below its content — without it the
   nowrap value inside sets an implicit floor and the shrink never happens. */
.dashv2-nacol--date {
  flex: 0 1 220px;
  min-width: 0;
}
.dashv2-nacol--client {
  flex: 0 1 330px;
  min-width: 0;
}
.dashv2-nacol--skill {
  flex: 0 1 200px;
  min-width: 0;
}
/* Real bases, not 0 — the same trap \`.dashv2-nscol--loc\` already documents on
   the No Show card. With \`flex: 1 1 0\` these two take only SURPLUS space, and
   once the row is over-subscribed there is none: at a 1024px viewport they
   collapsed to nothing, so Location rendered no value at all and the hired
   fraction read "12/" instead of "12/15" — the one number the row exists for.

   Given a basis they shrink in proportion with their neighbours instead, which
   is what the other three columns already do.

   \`flex-grow\` stays at 1 deliberately. These two are the columns that absorb
   the row's surplus, so dropping to \`0 1\` fixed the narrow case but pulled them
   in from 246px to 120/90 on a wide screen and left a gap before the chevron.
   Grow restores that; the basis only decides how the shrink is shared. The two
   bases are EQUAL so the wide layout is untouched to the pixel — equal basis
   plus equal grow gives the equal widths \`1 1 0\` produced — while still giving
   each column something to shrink from. */
.dashv2-nacol--loc {
  flex: 1 1 105px;
  min-width: 0;
}
.dashv2-nacol--fraction {
  flex: 1 1 105px;
  min-width: 0;
}
.dashv2-nafraction-val {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}
/* Sub-states are visually distinguished by colour (the Figma mock used one
   colour for all three; the AC requires distinction). */
.dashv2-nafraction-val.state-hired {
  color: var(--text-green);
}
.dashv2-nafraction-val.state-for_hired {
  color: var(--text-yellow);
}
.dashv2-nafraction-val.state-for_approval {
  color: var(--blue);
}

/* ── Shift Detail side panel ─────────────────────────────── */

/* The global app chrome (AppFrameV2) fixes its navbar at top: 0 with
   z-index: 3000 — far above this panel's 60. A panel at top: 0 therefore had
   its first 49px painted over: the 24px of padding plus the header row put the
   50px logo at y=24-74 (top half covered, reading as a clipped empty circle)
   and the 24px close button at y=24-48, entirely behind the navbar and so
   invisible. Both halves of GRAVY-10292 were this one offset.

   Docking below the navbar fixes it without a z-index war: the panel no longer
   intersects the global header, so it cannot be covered by it. --navbar-h is
   declared with the other tokens at the top of this file. */
/* Three rows: a fixed header, a body that scrolls, a fixed footer
   (GRAVY-10328). The panel itself no longer scrolls — it is the frame.

   This replaces \`position: sticky\` on the header. Sticky pinned the header
   correctly, but a sticky FOOTER on the same scrollport would have overlapped
   the last roster row, and the ticket is explicit that the actions must not
   obscure panel content. With the body as the only scroll container, the header
   and footer take their own space by construction and cannot cover anything. */
.dashv2-panel {
  position: fixed;
  top: var(--navbar-h);
  right: 0;
  bottom: 0;
  width: 330px;
  background: var(--white);
  border-left: 1px solid var(--stroke-gray);
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.06);
  /* The frame never scrolls; .dashv2-panel-body does. */
  overflow: hidden;
  z-index: 60;
  padding: 0;
  display: flex;
  flex-direction: column;
  font-family: 'Manrope', sans-serif;
  color: var(--black);
}
/* The one scrollport. \`min-height: 0\` is what actually lets it scroll: a flex
   item's default \`min-height: auto\` refuses to shrink below its content, so
   without it the body grows past the panel and pushes the footer off screen. */
.dashv2-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
/* AppFrameV2 only fixes the navbar at @smallDesktop; below that it sits in the
   normal grid flow, so a fixed offset would leave a gap at the top. */
@media (max-width: 991px) {
  .dashv2-panel {
    top: 0;
  }
}
.dashv2-panel-overlay {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 55;
}

/* Header */
/* The band that stays put while the body scrolls: the Needs attention badge
   and the close control on one row, then the skill heading. It is a fixed flex
   row of the panel rather than a sticky box, so scrolled content passes beneath
   it and can never show above it (see .dashv2-panel). */
.dashv2-panel-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 24px 12px;
  background: var(--white);
}
/* The badge sits left, the X right, whether or not the badge is there — the
   empty <span> placeholder is what holds the X in place on a non-critical
   shift. */
.dashv2-panel-headrow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
/* "Needs attention" — white on red, the calendar card's Critical band said in
   words (GRAVY-10328). Never rendered for a non-critical shift. */
.dashv2-panel-critical {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  width: fit-content;
}
/* The sticky footer: View job, and View QR for QR jobs. Outside the scrollport
   by construction, so it takes its own space instead of covering the last row
   of content. Buttons stack full width, matching the design. */
.dashv2-panel-footer {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--stroke-gray);
  background: var(--white);
}
.dashv2-panel-headmain {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 0;
  min-width: 0;
}
.dashv2-panel-logo {
  width: 50px;
  height: 50px;
  border-radius: 100px;
  overflow: hidden;
  background: var(--white);
  border: 1px solid var(--hl-gray);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* Initials fallback, shown when the client has no logo or the image fails.
     An empty circle reads as a broken panel; initials read as a client. */
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: var(--subtext);
}
.dashv2-panel-logo.is-fallback {
  background: var(--hl-gray);
}
.dashv2-panel-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dashv2-panel-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
  margin: 0;
}
.dashv2-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: var(--black);
  flex-shrink: 0;
}
.dashv2-panel-close:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}
/* An INVITE's state — Invited, Declined, or whatever else the server reports.
   Invited reads as green (the offer is live), Declined as purple with the
   design's info glyph. An unrecognised status falls through to the neutral base
   rather than being recoloured as something it is not. */
.dashv2-panel-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  background: var(--hl-gray);
  color: var(--subtext);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  width: fit-content;
}
.dashv2-panel-status svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.dashv2-panel-status.is-invited {
  background: var(--hl-green);
  color: var(--text-green);
}
/* Indigo, straight from the design — the palette above has no purple, and a
   declined invite is deliberately not red: it is information, not a failure. */
.dashv2-panel-status.is-declined {
  background: #eceafe;
  color: #4f46e5;
}
/* The shift's lifecycle status, moved out of the header into the tag block. */
.dashv2-panel-lifecycle {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  background: var(--blue-bg);
  color: var(--blue);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  width: fit-content;
}
/* An empty Invites / Hired / Recent activity section. The section still renders
   its heading and count — this line is what makes zero read as "nobody", not as
   a block that failed to load. */
.dashv2-panel-empty {
  margin: 0;
  padding: 8px 0 16px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--subtext);
}
.dashv2-panel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 8px 16px;
  border-radius: 8px;
  background: var(--white);
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  text-decoration: none;
}
.dashv2-panel-btn svg {
  width: 24px;
  height: 24px;
}
/* Full width, stacked — the footer is a column, so \`flex: 1 1 0\` here would
   stretch the button vertically instead of across. */
.dashv2-panel-btn.is-primary {
  width: 100%;
  border: 1px solid var(--green);
  color: var(--text-green);
  font-weight: 600;
}
.dashv2-panel-btn.is-secondary {
  width: 100%;
  border: 1px solid var(--stroke-gray);
  color: var(--black);
  font-weight: 400;
}

/* Gate + classification row */
.dashv2-panel-gaterow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.dashv2-panel-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-panel-chip svg {
  width: 24px;
  height: 24px;
}

/* Job details */
.dashv2-panel-details {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.dashv2-panel-jobblock {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dashv2-panel-jobid {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--text-green);
  text-decoration: none;
}
.dashv2-panel-jobid svg {
  width: 20px;
  height: 20px;
}
.dashv2-panel-shiftinfo {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.dashv2-panel-hours {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-panel-dot {
  width: 4px;
  height: 4px;
  border-radius: 100px;
  background: var(--black);
  flex-shrink: 0;
}
.dashv2-panel-role {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
  margin: 0;
}
.dashv2-panel-address {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--subtext);
  margin: 0;
}
.dashv2-panel-supervisor {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dashv2-panel-suptitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-panel-supname {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-panel-supphone {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--subtext);
}
.dashv2-panel-divider {
  height: 1px;
  width: 100%;
  background: var(--stroke-gray);
}

/* Workers */
/* No .dashv2-panel-fillrow: the "N of M hired · X% filled" summary it styled is
   removed (GRAVY-10328). The Invites and Hired headings carry the same counts,
   and the approved design has neither line. */
.dashv2-panel-worker {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding-bottom: 16px;
}
.dashv2-panel-worker .dashv2-avatar {
  width: 44px;
  height: 44px;
}
.dashv2-panel-workermeta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 0;
  min-width: 0;
}
.dashv2-panel-workername {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}
.dashv2-panel-workertags {
  display: flex;
  gap: 8px;
  align-items: center;
}
/* The Quality Gate verdict, as the approved design draws it: a boxed arrow and
   nothing else. The numeric score moved to the tooltip — it decides nothing
   (GRAVY-10313), and printing it beside an arrow it does not derive from is
   what made the two look like they should agree. */
.dashv2-panel-dep {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  flex-shrink: 0;
  color: var(--text-green);
}
.dashv2-panel-dep svg {
  width: 14px;
  height: 14px;
  stroke-width: 2.5;
}
/* Below the gate, whatever the score says. \`is-below\` is the hired row's tier;
   \`is-below-gate\` is set from the verdict itself, so an invite whose tier is a
   raw policy name still colours correctly. */
.dashv2-panel-dep.is-below,
.dashv2-panel-dep.is-below-gate {
  color: var(--red);
}
/* No .dashv2-panel-chip.is-off: an "off" gate no longer renders a muted chip.
   The updated design rules out a "Not enabled" tag entirely — the tag is
   absent, so there is nothing left to mute. */
/* The roster spans every post-shift status since GRAVY-10326, so this chip names
   the worker's state instead of always reading "Hired". Blue stays the default —
   the states Ops acts on are tinted below, and everything else reads as neutral
   information rather than competing with the Dependability warning beside it. */
.dashv2-panel-hiredtag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  border-radius: 8px;
  background: var(--blue-bg);
  color: var(--blue);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

/* Finished and settled — the common post-shift states. */
.dashv2-panel-hiredtag.is-completed,
.dashv2-panel-hiredtag.is-approved,
.dashv2-panel-hiredtag.is-paid {
  background: var(--hl-green);
  color: var(--text-green);
}
/* Needs someone to look at it. */
.dashv2-panel-hiredtag.is-rejected {
  background: var(--hl-red);
  color: var(--red);
}
.dashv2-panel-hiredtag.is-expired {
  background: var(--hl-gray);
  color: var(--subtext);
}
/* No .dashv2-panel-cta: the "Increase pay rate" button it styled is removed
   for this release (GRAVY-10294). The worker list ends on the last
   .dashv2-panel-worker, whose own 16px padding-bottom closes the block, so
   dropping the button leaves no empty container or collapsed gap behind. */

/* Recent activity */
.dashv2-panel-actitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}
/* A button rather than the styled span this shipped as, so it is clickable,
   focusable and reachable by keyboard — reset to keep the Figma's plain-link
   appearance (GRAVY-10294). */
.dashv2-panel-viewall {
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--text-green);
  cursor: pointer;
}
.dashv2-panel-viewall:focus-visible {
  outline: 2px solid var(--green);
  outline-offset: 2px;
  border-radius: 4px;
}
.dashv2-panel-actlist {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}
.dashv2-panel-actitem {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 16px;
}
.dashv2-panel-actrow {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashv2-panel-actrow .dashv2-avatar {
  width: 32px;
  height: 32px;
  font-size: 12px;
}
.dashv2-panel-acttext {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  flex: 1 1 0;
  min-width: 0;
}
.dashv2-panel-acttext b {
  font-weight: 700;
}
.dashv2-panel-actmeta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--subtext);
}
.dashv2-panel-loading {
  padding: 48px 0;
  text-align: center;
  color: var(--subtext);
  font-size: 14px;
}

/* ── Recent activity modal ("View all") ──────────────────── */
/* Sits above the Shift Detail panel (z-index 60) and its click-catching
   overlay (55), so the panel and calendar stay on screen, dimmed, and a click
   on this backdrop cannot fall through and close the panel underneath
   (GRAVY-10294). Above the global navbar (3000) too — unlike the panel, this
   is centred on the viewport and would otherwise be clipped by it. */
.dashv2-actmodal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(28, 28, 28, 0.45);
  z-index: 3100;
}
.dashv2-actmodal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: min(520px, calc(100vw - 32px));
  /* The list scrolls inside the body; the header and footer never leave. */
  max-height: min(640px, calc(100vh - 64px));
  border-radius: 12px;
  background: var(--white);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  z-index: 3101;
  font-family: 'Manrope', sans-serif;
  color: var(--black);
}
.dashv2-actmodal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 16px;
}
.dashv2-actmodal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
}
.dashv2-actmodal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 24px;
}
.dashv2-actmodal-state {
  padding: 32px 0;
  text-align: center;
  color: var(--subtext);
  font-size: 14px;
}
.dashv2-actmodal-more {
  width: 100%;
  margin-bottom: 16px;
  padding: 8px 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  color: var(--text-green);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
}
.dashv2-actmodal-more:disabled {
  color: var(--subtext);
  cursor: default;
}
.dashv2-actmodal-foot {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 24px;
  border-top: 1px solid var(--stroke-gray);
}
.dashv2-actmodal-back {
  padding: 8px 24px;
  border: 1px solid var(--green);
  border-radius: 8px;
  background: var(--white);
  color: var(--text-green);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
}
.dashv2-actmodal-back:hover {
  background: var(--hl-green);
}

/* Tab placeholder (stub queues) */
.dashv2-stub {
  padding: 48px 24px;
  text-align: center;
  color: var(--subtext);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.dashv2-retry {
  margin-top: 16px;
  padding: 8px 20px;
  border: 1px solid var(--border, #d0d5dd);
  border-radius: 8px;
  background: var(--surface, #fff);
  color: var(--text, #101828);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.dashv2-retry:disabled {
  opacity: 0.6;
  cursor: default;
}

/* ── Action-queue filter bar (GRAVY-10315) ───────────────── */
/* The three queues use the SHARED \`.dashv2-fbar\` / \`.dashv2-fseg\` bar defined
   with the Calendar bar above (GRAVY-10305) — Figma node 38995:64197 is the
   same horizontal segmented row, so it is the same CSS rather than a parallel
   copy that can drift. Only the Show/Hide pill's count badge and the Date range
   body are queue-specific.

   The old \`.dashv2-qfpopover\` and its checkbox/date rules are gone with the
   popover they styled; keeping dead selectors around is how the wrong control
   gets resurrected. */
.dashv2-qfcount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  margin-left: 4px;
  padding: 0 6px;
  border-radius: 100px;
  background: var(--green);
  color: var(--white);
  font-size: 12px;
  font-weight: 600;
}

/* Date range body inside a segment menu. */
.dashv2-fseg-dates {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  min-width: 240px;
}
.dashv2-fseg-date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  color: var(--black);
}
.dashv2-fseg-date input {
  flex: 1 1 0;
  min-width: 0;
  padding: 4px 8px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
}
.dashv2-fseg-date:focus-within {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}

/* ── ≤1439: Shift Detail rail ────────────────────────────── */
/* Placed at the END of the file on purpose. These override \`.dashv2-panel\` and
   the roster row, which are declared ~200 lines above; an equal-specificity
   rule in the earlier ≤1439 block loses on source order and silently does
   nothing (it did — the panel measured 330 at every width until this moved).

   Figma \`shift-info\` (39124:32862): the rail is 280 wide with 24px padding, so
   its content box is 232 — against 330/282 at 1440+. The roster row is what
   makes 232 work, and the frame gives its geometry directly: avatar 32 at x=0,
   name at x=44 (so a 12px gap), name 20px tall = 14px at line-height 1.4,
   phone glyph 20px at x=212. */
@media (max-width: 1439px) {
  .dashv2-panel {
    width: 280px;
  }
  .dashv2-panel-worker .dashv2-avatar {
    width: 32px;
    height: 32px;
  }
  .dashv2-panel-workername {
    font-size: 14px;
  }
}

/* ── "Ops on duty today" strip ───────────────────────────── */
/* Figma \`ops-sched\` (39124:33453), measured off the frame: the card is 697×86
   inside a 24px gutter; the title sits at (16,12) and the roster row at (16,50),
   so the card padding is 16 / 12 and the two rows are 16 apart. Entries are 24px
   tall and 16px apart (x=0/212/448 for widths 196/220/210). Within an entry: an
   8px dot, the name 16px away from it, the hours 8px after the name, and a 24px
   call button 16px after that.

   Rendered only when the strip has entries — see OpsOnDuty.tsx on why that is
   the branch that currently runs. */
.dashv2-ops {
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
  padding: 12px 16px;
  margin-bottom: 24px;
}
.dashv2-ops-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-ops-title svg {
  width: 20px;
  height: 20px;
}
.dashv2-ops-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
}
.dashv2-ops-item {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
}
.dashv2-ops-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--green);
  flex: 0 0 auto;
}
.dashv2-ops-dot.is-off {
  background: var(--stroke-gray);
}
/* The name sits 16px from the dot in the frame (dot 8 at x=0, name at x=16). */
.dashv2-ops-name {
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-ops-hours {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--subtext);
}
.dashv2-ops-call {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-left: 8px;
  border-radius: 50%;
  background: var(--green);
  color: var(--white);
  flex: 0 0 auto;
}
.dashv2-ops-call svg {
  width: 14px;
  height: 14px;
}

/* The strip belongs to the ≤1439 design; at 1440+ the dashboard has no such
   band, so it stays out of the way rather than being shown at a width that
   never specified it. */
@media (min-width: 1440px) {
  .dashv2-ops {
    display: none;
  }
}

/* ── Shift Detail: labelled info block (GRAVY-10328) ─────── */
/* Figma 38851:108868. Client / Address / Shift supervisor became labelled
   fields — 16px label over a 14px value, 8px apart, blocks 16px apart — and
   collapse together behind a centred "Hide info" toggle. */
.dashv2-panel-infoblock {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
/* REQUIRED, not belt-and-braces. The UA stylesheet's \`[hidden] { display: none }\`
   is a bare attribute selector, so the class rule above wins on specificity and
   the block stays on screen with \`hidden\` set — "Hide info" flipped
   \`aria-expanded\` and hid nothing. Any element given \`display\` by a class needs
   its own \`[hidden]\` rule. */
.dashv2-panel-infoblock[hidden] {
  display: none;
}
.dashv2-panel-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.dashv2-panel-fieldlabel {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-panel-fieldvalue {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
  overflow-wrap: break-word;
}
.dashv2-panel-infotoggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-panel-infotoggle svg {
  width: 24px;
  height: 24px;
  transition: transform 0.12s;
}

/* ── Day view (GRAVY-10329) ──────────────────────────────── */
/* Figma \`Admin-Dashboard x 1024\` — the Today/Week/Day control (39124:32612)
   and the stacked shift cards (\`Item 1\`/\`Item 3\`, 39124:32648 / 32833). */
.dashv2-navgroup {
  display: flex;
  align-items: center;
  gap: 24px;
}
.dashv2-viewtoggle {
  display: flex;
  align-items: center;
  padding: 2px 2px 2px 0;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: #fcfcfc;
}
.dashv2-viewtoggle-btn {
  height: 32px;
  padding: 8px 16px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--black);
}
/* Greyed rather than hidden when it would do nothing — the frame's own
   treatment, and it keeps the control's width stable. */
.dashv2-viewtoggle-btn:disabled {
  color: var(--deactivated);
  cursor: default;
}
.dashv2-viewtoggle-btn.is-active {
  border-radius: 6px;
  background: var(--green);
  color: var(--white);
  font-weight: 600;
}

.dashv2-daylist {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0 24px;
}
/* The card's own border and background ARE the priority signal (GRAVY-10335).
   Filled is the neutral resting state; Critical and At risk tint the whole row,
   so an admin scanning the day sees the hierarchy without reading a word.

   The two washes are sampled straight from Figma 39391:14056 and are much
   fainter than --hl-red / --hl-yellow, which are chip fills: at full width a
   chip tint reads as an error state rather than a priority. They have no token
   for that reason — a token implies reuse, and these are specific to a
   full-bleed row. The BORDERS are tokens, and match the week grid's bands. */
.dashv2-daycard {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border: 1px solid var(--stroke-gray);
  border-radius: 8px;
  background: var(--white);
}
.dashv2-daycard.is-critical {
  border-color: var(--stroke-red);
  background: #fffaf9;
}
.dashv2-daycard.is-at_risk {
  border-color: var(--stroke-yellow);
  background: #fcfaf3;
}
/* \`is-filled\` and \`is-unknown\` inherit the neutral card above deliberately —
   naming them here would invite someone to tint them. */
.dashv2-daycard-head {
  display: flex;
  align-items: center;
  gap: 24px;
}
/* \`min-width: 0\` is what lets a long client name ellipsise instead of pushing
   the badge and chevron out of the card. */
.dashv2-daycard-main {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}
.dashv2-daycard-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  color: var(--black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashv2-daycard-lock {
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
  color: var(--subtext);
}
.dashv2-daycard-role,
.dashv2-daycard-time,
.dashv2-daycard-loc {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashv2-daycard-role {
  font-weight: 400;
  color: var(--black);
}
.dashv2-daycard-time {
  font-weight: 600;
  color: var(--black);
}
.dashv2-daycard-loc {
  font-weight: 400;
  color: var(--subtext);
}
.dashv2-daycard-badge {
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--red);
  color: var(--white);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
.dashv2-daycard-open {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--black);
}
.dashv2-daycard-open svg {
  width: 24px;
  height: 24px;
}

/* No \`.is-alert\` variant any more: the tinted, bordered box this styled was the
   ONLY thing distinguishing an unfilled shift, and it drew Critical and At risk
   identically (GRAVY-10335). The card carries the state now, and the fraction
   below is a solid pill coloured by its own rule. */
.dashv2-daycard-fill {
  display: flex;
  align-items: center;
  padding: 0;
}
/* A solid pill, white on the state colour — Figma 39391:14056 draws it as the
   design-system status chip rather than as bare coloured text, which at 14px
   was too quiet to survive a full-width row. */
.dashv2-daycard-metric {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  background: var(--hl-gray);
  color: var(--subtext);
}
.dashv2-daycard-metric svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}
.dashv2-daycard-metric.is-filled {
  background: var(--green);
  color: var(--white);
}
/* Nobody hired, and imminent-and-partly-staffed, are both red. \`is-empty\` is
   deliberately NOT folded into \`is-critical\`: an At-risk shift with 0 hired is
   red too, which is the whole reason the pill has a rule of its own. */
.dashv2-daycard-metric.is-empty,
.dashv2-daycard-metric.is-critical {
  background: var(--red);
  color: var(--white);
}
.dashv2-daycard-metric.is-atrisk {
  background: var(--sec-yellow);
  color: var(--white);
}
/* \`is-unknown\` keeps the neutral base above: an older API sending no
   fill_status must not have a colour invented for it. */

.dashv2-dayempty {
  padding: 48px 16px;
  text-align: center;
  color: var(--subtext);
  font-size: 16px;
  line-height: 1.4;
}

/* ── Shift Detail: Invites / Hired sections (GRAVY-10328) ── */
/* Figma 39273:35064. A 24px heading row carrying the label and count with a
   collapse chevron, then the rows. The count sits in the heading so it stays
   legible while the section is collapsed. */
.dashv2-panel-section {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}
.dashv2-panel-sectionhead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black);
}
.dashv2-panel-sectionhead svg {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  transition: transform 0.12s;
}
/* Same \`[hidden]\` guard the info block needs: a class-set \`display\` outranks
   the UA's bare \`[hidden]\` rule, so the section would collapse its chevron and
   keep its rows on screen. */
.dashv2-panel-section > [hidden] {
  display: none;
}
.dashv2-panel-status.is-invited {
  background: var(--hl-green, #e7f4e6);
  color: var(--text-green);
}
.dashv2-panel-status.is-declined {
  background: #eee7fc;
  color: #2d2bd9;
}

/* The Show/Hide word occupies the same box in both states, so toggling the
   filter bar cannot resize its own button (GRAVY-10332). Sized in \`em\` so it
   tracks the font rather than pinning a pixel measurement of one string. */
.dashv2-showbtn-word {
  display: inline-block;
  min-width: 2.7em;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/DashboardV2/dashboardV2.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,0EAA0E;EAC1E,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;;EAEhB;6EAC2E;EAC3E,gBAAgB;;EAEhB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT;;6EAE2E;EAC3E,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;;;;;;;;;;;;;kDAckD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;;;;qBAKqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,6CAA6C;AAC/C;AACA,2EAA2E;AAC3E;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;kDACkD;AAClD;EACE,QAAQ;EACR,YAAY;EACZ,mDAAmD;EACnD,gBAAgB;EAChB,sBAAsB;AACxB;AACA;sEACsE;AACtE;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+DAA+D;AAC/D;mDACmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;mCACmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4DAA4D;EAC5D,cAAc;EACd,mBAAmB;AACrB;AACA,0EAA0E;AAC1E;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;gEACgE;AAChE;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,yCAAyC;EACzC;;;0BAGwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;4BAC0B;EAC1B,qBAAqB;AACvB;AACA;qDACqD;AACrD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;+CAE+C;AAC/C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,4EAA4E;EAC5E,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB;;;oCAGkC;EAClC,2BAA2B;AAC7B;;AAEA;mDACmD;AACnD;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;;;;;iEAKiE;AACjE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;;;gBAGc;EACd,YAAY;AACd;AACA,4EAA4E;AAC5E;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,wBAAwB;EACxB,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;aAuBa;AACb;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;;;;;;+BAU+B;AAC/B;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;qBAMqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;;;EAGE,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;;EAGE,YAAY;EACZ,eAAe;AACjB;AACA;;;EAGE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ;;wCAEsC;EACtC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;2EAG2E;AAC3E;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;;iFAIiF;;AAEjF;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;qEACqE;AACrE;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;;iFAMiF;AACjF;;EAEE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,mBAAmB;AACrB;AACA;;yEAEyE;AACzE;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;0CACwC;EACxC,mBAAmB;EACnB;;;;6EAI2E;EAC3E,eAAe;EACf,gBAAgB;AAClB;AACA;;2EAE2E;AAC3E;;;EAGE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E,+DAA+D;AAC/D;;;;;;;;;;;;;;2CAc2C;AAC3C;EACE,aAAa;EACb;;uBAEqB;EACrB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;;;EAGE,gBAAgB;EAChB,YAAY;AACd;;AAEA;0DAC0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;oCAEoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;mBAmBmB;AACnB;EACE,aAAa;EACb;;qDAEmD;EACnD,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;;;;EAIE,gBAAgB;EAChB,YAAY;AACd;AACA;;QAEQ;AACR;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;kDACkD;AAClD;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;uEAgBuE;AACvE,+DAA+D;AAC/D;;;;;;;;;;;;;;;;8EAgB8E;AAC9E;EACE;;;4EAG0E;EAC1E;;;IAGE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;gCAC8B;EAC9B;;;IAGE,kBAAkB;EACpB;;EAEA;;;8CAG4C;EAC5C;;IAEE,aAAa;EACf;EACA;;yCAEuC;EACvC;;;;;;yCAMuC;EACvC;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;;;mDAIiD;EACjD;IACE,WAAW;IACX;wEACoE;IACpE,YAAY;IACZ,uBAAuB;EACzB;EACA;;;;;;;;;qEASmE;EACnE;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;;wBAEsB;EACtB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;;;;2EAIyE;EACzE;IACE;;UAEM;IACN,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;;uCAKqC;EACrC;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB;;;uEAGmE;IACnE,yBAAyB;EAC3B;EACA;;;;;;;;;0EASwE;EACxE;IACE;;uDAEmD;IACnD,SAAS;EACX;EACA;;;;IAIE,WAAW;EACb;AACF;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;;;;;;6EAM6E;AAC7E;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;;;;;;;;;;;;;;;0CAe0C;AAC1C;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;wDACwD;AACxD;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;;;;;;;;;4DAS4D;AAC5D;;;;;;;+EAO+E;AAC/E;EACE,eAAe;EACf,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,yCAAyC;EACzC,2CAA2C;EAC3C,sDAAsD;EACtD,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;;+EAE+E;AAC/E;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;sEACsE;AACtE;EACE;IACE,MAAM;EACR;AACF;AACA;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA,WAAW;AACX;;;wDAGwD;AACxD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;;WAEW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;AACA;kEACkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;+DAE+D;AAC/D;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd;0EACwE;EACxE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;yDAGyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;+EAC+E;AAC/E;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;iCAEiC;AACjC;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;qDACqD;AACrD;EACE,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA,YAAY;AACZ;;8CAE8C;AAC9C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;;;mDAGmD;AACnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;;6CAE6C;AAC7C;;EAEE,iBAAiB;AACnB;AACA;;8CAE8C;AAC9C;;;gFAGgF;AAChF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;;;EAGE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;;;2EAG2E;;AAE3E,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;8BAE8B;AAC9B;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;;;;qEAIqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,yEAAyE;EACzE,0CAA0C;EAC1C,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;;;;;;;;sBAQsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;;;;;;;;;+BAS+B;AAC/B;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;;;;;;;;oCAQoC;AACpC;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;wBAEwB;AACxB;EACE;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;;2DAE2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;;;6BAI6B;AAC7B;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;0EAC0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;wDACwD;AACxD;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;AACA;;;;;;;;6EAQ6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;wDACwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;2CAC2C;AAC3C;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;oDAGoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;;+CAE+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;uEAEuE;AACvE;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;wDACwD;;AAExD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;4CAE4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;AACA;;6BAE6B;AAC7B;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;2EAE2E;AAC3E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/*\n * Dashboard V2 — pixel-perfect styles for the GravyWork 2.0 Baseline\n * Calendar tab (Figma node 37530-68068). Every value here is transcribed\n * from Figma Dev Mode (get_design_context) per component, so this file is the\n * single source of truth for the page. Scoped under `.dashv2`.\n *\n * Font: Manrope, line-height 1.4, letter-spacing 0. Spacing scale: 4/8/12/16/24.\n */\n\n.dashv2 {\n  --green: #44a735;\n  --text-green: #2e8722;\n  --hl-green: #e7f4e6;\n  --stroke-green: #a7daa1;\n  --sec-yellow: #eca300;\n  --text-yellow: #bb8700;\n  --hl-yellow: #fff4d8;\n  --stroke-yellow: #ffcc7f;\n  --red: #cf040c;\n  --hl-red: #ffdfd8;\n  --stroke-red: #f86d4f;\n  /* Figma `accent-text/text-deactivated-text` — the greyed Today control. */\n  --deactivated: #979797;\n  --blue: #4671ea;\n  --blue-bg: #e4f2ff;\n  --black: #1c1c1c;\n  --subtext: #5b5b5b;\n  --stroke-gray: #dadada;\n  --hl-gray: #eaeaea;\n  --surface: #fcfcfc;\n  --white: #ffffff;\n\n  /* Height of the fixed global navbar. Keep in sync with NAVBAR_HEIGHT in\n     src/components/AppFrameV2.tsx — the Shift Detail panel docks below it. */\n  --navbar-h: 49px;\n\n  font-family: 'Manrope', sans-serif;\n  color: var(--black);\n  letter-spacing: 0;\n  -webkit-font-smoothing: antialiased;\n}\n.dashv2 * {\n  box-sizing: border-box;\n}\n\n/* ── Tab bar ─────────────────────────────────────────────── */\n.dashv2-tabs {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--stroke-gray);\n}\n.dashv2-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  /* 48 EXACT, per the frame (`h-[48px]`), rather than left to fall out of\n     12 + 20 + 12 + a 3px border = 47. `box-sizing: border-box` is set for\n     `.dashv2 *` at the top of this file, so the border sits inside the 48. */\n  height: 48px;\n  padding: 12px 16px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: var(--black);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -1px;\n}\n.dashv2-tab svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-tab.is-active {\n  font-weight: 600;\n  border-bottom-color: var(--green);\n}\n.dashv2-tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 4px 8px;\n  border-radius: 100px;\n  background: var(--hl-red);\n  color: var(--red);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n/* ── Controls: week-nav (left) + summary (right) ─────────── */\n/* Week nav on the left, summary pills + Show on the right.\n *\n * WRAPS rather than overflowing. The two groups are sized by their content —\n * nav 321px, summary 441px — and neither can shrink, because every label inside\n * them is `nowrap`. Below ~762px of content width they therefore did not merely\n * crowd: the summary ran straight past the container. At a 1024px viewport the\n * app shell leaves 704px, so the Show button ended at x=1050, 58px beyond the\n * page and outside the viewport entirely.\n *\n * Wrapping keeps every element at the size the design gives it and moves the\n * whole right-hand group to its own line only when there is genuinely no room —\n * so at the widths this was drawn for the layout is pixel-identical, and nothing\n * is ever hidden or clipped. `margin-left: auto` keeps that group right-aligned\n * whether it shares the line or not (`space-between` alone would flush it left\n * once it is the only item on the second line). */\n.dashv2-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  padding: 8px 0;\n}\n.dashv2-weeknav {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.dashv2-nav-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.dashv2-iconbtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 0;\n  background: var(--white);\n  cursor: pointer;\n  color: var(--black);\n  padding: 0;\n}\n.dashv2-iconbtn svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-range {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.dashv2-today-btn {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--surface);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n\n.dashv2-summary {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.dashv2-summary-pills {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n/* Each pill is a BUTTON — the Calendar's fill-rate quick filter (GRAVY-10319),\n   not a read-only count. Geometry and colour are unchanged from what shipped;\n   what is new is the interactive state, transcribed from the approved prototype\n   (`ui-prototype/shift-risk-monitoring`, `.risk-badge`): the same hue at 0.5\n   alpha instead of 0.24, a coloured hover ring, and a separator + X revealed on\n   the active chip. */\n.dashv2-summary-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 4px 12px;\n  border-radius: 8px;\n  border: 1px solid;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: box-shadow 0.12s, background 0.12s;\n}\n.dashv2-summary-pill svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-summary-pill.is-critical {\n  background: rgba(255, 223, 216, 0.24);\n  color: var(--red);\n  border-color: var(--stroke-red);\n}\n.dashv2-summary-pill.is-critical:hover {\n  box-shadow: 0 0 0 3px rgba(207, 4, 12, 0.1);\n}\n.dashv2-summary-pill.is-critical.is-active {\n  background: rgba(255, 223, 216, 0.5);\n}\n.dashv2-summary-pill.is-atrisk {\n  background: rgba(255, 244, 216, 0.24);\n  color: var(--text-yellow);\n  border-color: var(--stroke-yellow);\n}\n.dashv2-summary-pill.is-atrisk:hover {\n  box-shadow: 0 0 0 3px rgba(236, 163, 0, 0.1);\n}\n.dashv2-summary-pill.is-atrisk.is-active {\n  background: rgba(255, 244, 216, 0.5);\n}\n.dashv2-summary-pill.is-filled {\n  background: rgba(231, 244, 230, 0.24);\n  color: var(--text-green);\n  border-color: var(--stroke-green);\n}\n.dashv2-summary-pill.is-filled:hover {\n  box-shadow: 0 0 0 3px rgba(68, 167, 53, 0.12);\n}\n/* The one band whose BORDER also changes when active, per the prototype. */\n.dashv2-summary-pill.is-filled.is-active {\n  background: rgba(231, 244, 230, 0.5);\n  border-color: var(--green);\n}\n.dashv2-summary-pill:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n/* Only on the active chip — it says the next click clears the filter. Both are\n   decorative; the button itself is the control. */\n.dashv2-pill-sep {\n  width: 0;\n  height: 16px;\n  /* On top of the 8px flex gap, per the prototype. */\n  margin-left: 4px;\n  border-left: 1px solid;\n}\n/* The separator takes the band's STROKE colour, not the label's — the two differ\n   in all three bands. The X takes the label colour, so it inherits. */\n.dashv2-summary-pill.is-critical .dashv2-pill-sep {\n  border-color: var(--stroke-red);\n}\n.dashv2-summary-pill.is-atrisk .dashv2-pill-sep {\n  border-color: var(--stroke-yellow);\n}\n.dashv2-summary-pill.is-filled .dashv2-pill-sep {\n  border-color: var(--green);\n}\n.dashv2-pill-x {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n.dashv2-pill-x svg {\n  width: 16px;\n  height: 16px;\n}\n.dashv2-showbtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-showbtn svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* ── Calendar filter bar (Figma 37673:100905, GRAVY-10305) ─ */\n/* Row is 44px tall and full width: two bordered icon-anchored groups 24px\n   apart on the left, Reset filters pinned right. */\n.dashv2-fbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 4px 0 12px;\n  flex-wrap: wrap;\n}\n.dashv2-fbar-groups {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n.dashv2-fgroup {\n  display: flex;\n  align-items: stretch;\n  height: 44px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n}\n/* The icon cell: 20px glyph, its own padding, divided from the first segment\n   by that segment's left border. */\n.dashv2-fgroup-icon {\n  display: inline-flex;\n  align-items: center;\n  /* 36px cell (8px + 20px glyph + 8px) in the funnel group. */\n  padding: 0 8px;\n  color: var(--black);\n}\n/* The eye group's cell is 44px in the design: 12px + 20px glyph + 12px. */\n.dashv2-fgroup + .dashv2-fgroup .dashv2-fgroup-icon {\n  padding: 0 12px;\n}\n.dashv2-fgroup-icon svg {\n  width: 20px;\n  height: 20px;\n}\n/* Segments are separated by 1px dividers; the group's own border supplies the\n   outer edges, so only the left divider is drawn per segment. */\n.dashv2-fseg {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  border-left: 1px solid var(--stroke-gray);\n  /* Eye-group cells are 120px in the design, funnel-group cells 160px. The\n     divider is part of that width, so it is set here rather than on the button\n     — otherwise each segment renders 1px wide and the groups drift off the\n     design by 3px each. */\n  min-width: 120px;\n}\n.dashv2-fgroup:first-child .dashv2-fseg {\n  min-width: 160px;\n}\n.dashv2-fseg-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  padding: 10px 4px 10px 16px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  /* Funnel-group cells are PLACEHOLDERS (\"Client\") and render grey until a\n     selection is applied. */\n  color: var(--subtext);\n}\n/* Eye-group cells are not placeholders — \"All status\" is a real default state,\n   so the design renders them black from the start. */\n.dashv2-fgroup + .dashv2-fgroup .dashv2-fseg-btn {\n  color: var(--black);\n}\n.dashv2-fseg-btn.is-active {\n  color: var(--black);\n  font-weight: 600;\n}\n.dashv2-fseg-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.dashv2-fseg-btn:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: -2px;\n  border-radius: 8px;\n}\n.dashv2-fseg-btn svg {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  color: var(--black);\n}\n.dashv2-fseg-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Each segment opens its OWN scoped list, rather than all dimensions sharing\n   one long menu. Capped so a tenant with hundreds of clients scrolls inside\n   the menu instead of covering the calendar. */\n.dashv2-fseg-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: -1px;\n  z-index: 20;\n  min-width: 220px;\n  max-width: 320px;\n  background: var(--white);\n  border: 1px solid var(--stroke-gray);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n.dashv2-fseg-menu.align-right {\n  left: auto;\n  right: -1px;\n}\n.dashv2-fseg-options {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n.dashv2-fseg-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--black);\n  cursor: pointer;\n}\n.dashv2-fseg-option:hover {\n  background: var(--surface);\n}\n.dashv2-fseg-option:focus-within {\n  outline: 2px solid var(--blue);\n  outline-offset: -2px;\n}\n.dashv2-fseg-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-top: 1px solid var(--stroke-gray);\n}\n.dashv2-fseg-clear,\n.dashv2-fseg-apply {\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid var(--stroke-gray);\n  background: var(--white);\n  color: var(--black);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.dashv2-fseg-apply {\n  border-color: var(--green);\n  background: var(--green);\n  color: var(--white);\n}\n.dashv2-fseg-clear:disabled {\n  color: var(--subtext);\n  opacity: 0.5;\n  cursor: default;\n}\n.dashv2-fseg-clear:focus-visible,\n.dashv2-fseg-apply:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n\n.dashv2-freset {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-freset svg {\n  width: 20px;\n  height: 20px;\n}\n/* Greyed with nothing applied, matching the design's default state. */\n.dashv2-freset:disabled {\n  color: var(--subtext);\n  cursor: default;\n}\n.dashv2-freset:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* ── Calendar grid ───────────────────────────────────────── */\n.dashv2-calendar {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n.dashv2-daycol {\n  min-width: 0;\n}\n.dashv2-daycol.is-today {\n  background: rgba(231, 244, 230, 0.5);\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n/* Day header */\n.dashv2-dayhead {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 16px 8px;\n  border-bottom: 1px solid var(--stroke-gray);\n}\n.dashv2-daycol.is-today .dashv2-dayhead {\n  border-bottom: 3px solid var(--green);\n}\n.dashv2-dayhead-top {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.dashv2-weekday {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-daycol.is-today .dashv2-weekday {\n  font-weight: 600;\n}\n.dashv2-fillpct {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 4px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-fillpct.band-high {\n  background: var(--hl-green);\n  color: var(--text-green);\n}\n.dashv2-fillpct.band-mid {\n  background: var(--hl-yellow);\n  color: var(--text-yellow);\n}\n.dashv2-fillpct.band-low {\n  background: var(--hl-red);\n  color: var(--red);\n}\n.dashv2-fillpct.band-none {\n  background: var(--hl-gray);\n  color: var(--subtext);\n}\n.dashv2-daynum {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 100px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-daycol.is-today .dashv2-daynum {\n  background: var(--green);\n  color: var(--white);\n  font-weight: 800;\n}\n\n/* Shift list */\n.dashv2-shiftlist {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 4px;\n}\n\n/* ── Shift card ──────────────────────────────────────────── */\n.dashv2-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--surface);\n  overflow: hidden;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  /* Reset for when the card renders as a <button> (opens the detail panel). */\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n  appearance: none;\n  /* Lets the status row respond to the card's own width rather than the\n     viewport's, so deep browser zoom and narrow windows behave identically\n     (the seven calendar columns are minmax(0, 1fr), so a card can get very\n     narrow at any viewport size). */\n  container-type: inline-size;\n}\n\n/* The card is the keyboard target when it renders as a <button>; make that\n   visible rather than relying on the UA default. */\n.dashv2-card:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n.dashv2-card.level-warn {\n  background: rgba(255, 244, 216, 0.32);\n  border-color: var(--stroke-yellow);\n}\n.dashv2-card.level-critical {\n  background: #fff4f2;\n  border-color: var(--stroke-red);\n}\n\n.dashv2-quickinfo {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n/* Dependability, the status ribbon and the lock can all apply at once. The row\n   must wrap onto extra lines instead of running past the card edge, where the\n   card's `overflow: hidden` would clip a badge into an unreadable fragment.\n   12px both ways, per Figma (node 38730:44565 lays the pills out at 12px\n   between siblings and 12px between rows). Wrapping is what prevents the\n   clipping, so the gap does not need to be shaved to buy room. */\n.dashv2-card-toprow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  max-width: 100%;\n}\n.dashv2-lock {\n  display: inline-flex;\n  flex: none;\n  width: 20px;\n  height: 20px;\n  color: var(--black);\n}\n\n/* Status ribbons — all 12px SemiBold, rounded 8, no icon except Dependability */\n.dashv2-ribbon {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  /* Flex items default to min-width: auto, which refuses to shrink below\n     min-content and pushes the row past the card. Allow the shrink and let the\n     label ellipsize instead — a truncated label still reads, a clipped badge\n     does not. */\n  min-width: 0;\n}\n/* The glyph carries the meaning when space is tight, so it never shrinks. */\n.dashv2-ribbon svg {\n  flex: none;\n}\n.dashv2-ribbon-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashv2-ribbon.type-dependability {\n  gap: 2px;\n  padding: 2px 8px 2px 4px;\n  background: transparent;\n  border: 1px solid var(--stroke-red);\n  color: var(--red);\n}\n.dashv2-ribbon.type-dependability svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-ribbon.type-starts_in {\n  background: var(--red);\n  color: var(--white);\n}\n.dashv2-ribbon.type-in_progress {\n  background: var(--blue-bg);\n  color: var(--blue);\n}\n.dashv2-ribbon.type-needs_approval {\n  background: var(--hl-yellow);\n  color: var(--text-yellow);\n}\n\n/* Last-resort fallback for a genuinely tiny card (deep browser zoom, or a\n   narrow window divided across seven columns): drop to the arrow glyph alone\n   and keep the label as the pill's accessible name, so the state is never\n   lost.\n\n   The threshold is measured against the card's CONTENT box, not its border\n   box — that is what a size container query resolves against. The card is\n   12px-padded with a 1px border, so its content box runs 26px narrower than\n   the column: a 152px card at a 1440px viewport queries as 126px.\n\n   The full \"Dependability\" pill measures 111px (Figma has it at 114px), so the\n   label fits on a row of its own down to ~111px of content width. An earlier\n   threshold of 150px therefore hid it at every realistic desktop width —\n   1600px viewport included — leaving a bare red arrow where the design shows\n   the labelled pill. 100px keeps the fallback for the case it was written for\n   and nothing else.\n\n   This rule is a legibility nicety, not the anti-clipping mechanism: wrapping\n   plus `min-width: 0` and the ellipsizing label already hold every indicator\n   inside the card on their own, at every width down to ~75px.\n\n   Progressive enhancement: where @container is unsupported the label simply\n   ellipsizes via .dashv2-ribbon-label instead — degraded, but still not\n   clipped. */\n@container (max-width: 100px) {\n  .dashv2-ribbon.type-dependability {\n    padding: 2px 4px;\n  }\n  .dashv2-ribbon.type-dependability .dashv2-ribbon-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    border: 0;\n    overflow: hidden;\n    clip-path: inset(50%);\n  }\n}\n\n.dashv2-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n.dashv2-card-title {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.4;\n  margin: 0;\n  color: var(--black);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.dashv2-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n.dashv2-card-meta p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashv2-card-time {\n  font-weight: 600;\n  color: var(--black);\n  white-space: nowrap;\n}\n/* A card narrower than its own time range lets the END time fall off the edge:\n   \"5:00PM-9:00PM\" needs ~109px, and seven day columns in the 704px a 1024px\n   viewport leaves gives each card ~91. Ellipsis is the right answer for an\n   identity (the title has a `title` attribute and the client is recognisable\n   from its start), but a shift you cannot see the end of is missing the thing\n   the card exists to tell you.\n\n   So below the width where it fits, the range wraps after its hyphen instead —\n   two short lines, nothing lost. Scoped with the same `@container` the ribbon\n   rule uses, so it keys off the CARD rather than the viewport and stays correct\n   however the grid is sized. */\n@container (max-width: 118px) {\n  .dashv2-card-time {\n    white-space: normal;\n  }\n}\n.dashv2-card-role {\n  font-weight: 400;\n  color: var(--black);\n}\n.dashv2-card-loc {\n  font-weight: 400;\n  color: var(--subtext);\n}\n\n.dashv2-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.dashv2-hired {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-hired.status-filled {\n  background: var(--green);\n  color: var(--white);\n}\n.dashv2-hired.status-at_risk {\n  background: var(--sec-yellow);\n  color: var(--white);\n}\n.dashv2-hired.status-critical {\n  background: var(--hl-red);\n  color: var(--red);\n}\n.dashv2-chevron {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  color: var(--black);\n}\n\n/* Empty day */\n.dashv2-empty {\n  padding: 24px 8px;\n  color: var(--subtext);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.4;\n  text-align: center;\n}\n\n/* ── Queue tabs: title row ───────────────────────────────── */\n.dashv2-queue-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n.dashv2-queue-heading {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.4;\n  margin: 0;\n}\n.dashv2-queue-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 16px;\n}\n.dashv2-queue-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--subtext);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* ── Missing-timesheet row actions (GRAVY-10307 / 10318) ──────────────────\n   Both row actions are now ICONS in their own grid tracks. The text button they\n   replaced (\"Enter hours\", plus the phone number rendered as a link) was wide\n   enough to squeeze Check-in/Check-out/Break/Total into each other, which is\n   the defect GRAVY-10318 fixes — so the geometry here is load-bearing, not\n   decoration. Call reuses `.dashv2-nscall` from the No Show card: same action,\n   same affordance. */\n.dashv2-tsedit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n}\n.dashv2-tsedit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 0;\n  border-radius: 100px;\n  background: transparent;\n  color: var(--green);\n  cursor: pointer;\n}\n.dashv2-tsedit-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.7);\n}\n.dashv2-tsedit-btn svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-tsedit-btn:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n.dashv2-tsedit-btn:disabled {\n  color: var(--subtext);\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ── Enter Hours dialog (GRAVY-10307) ─────────────────────── */\n.dashv2-ehoverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.4);\n}\n.dashv2-ehdialog {\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 24px;\n  border-radius: 12px;\n  background: var(--white);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);\n}\n.dashv2-ehtitle {\n  margin: 0 0 16px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-ehcontext {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  margin: 0 0 20px;\n  padding: 12px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--surface);\n}\n.dashv2-ehcontext > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.dashv2-ehcontext dt {\n  font-size: 13px;\n  color: var(--subtext);\n}\n.dashv2-ehcontext dd {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n}\n.dashv2-ehfields {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.dashv2-ehfield {\n  display: flex;\n  flex: 1 1 120px;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: var(--subtext);\n}\n.dashv2-ehfield input,\n.dashv2-ehfield select {\n  height: 40px;\n  padding: 0 10px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  color: var(--black);\n  font-family: inherit;\n  font-size: 14px;\n}\n.dashv2-eherror {\n  margin: 12px 0 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--red);\n}\n.dashv2-ehfoot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 24px;\n}\n.dashv2-ehcancel,\n.dashv2-ehsave,\n.dashv2-ehresolve {\n  height: 36px;\n  padding: 0 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  color: var(--black);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.dashv2-ehresolve {\n  border-color: var(--green);\n  background: var(--green);\n  color: var(--white);\n}\n.dashv2-ehcancel:disabled,\n.dashv2-ehsave:disabled,\n.dashv2-ehresolve:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n.dashv2-ehcancel:focus-visible,\n.dashv2-ehsave:focus-visible,\n.dashv2-ehresolve:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n\n/* ── Queue pagination (GRAVY-10304) ──────────────────────── */\n.dashv2-qpage {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 4px 0;\n  flex-wrap: wrap;\n}\n.dashv2-qpage-range {\n  font-size: 13px;\n  color: var(--subtext);\n}\n.dashv2-qpage-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.dashv2-qpage-count {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--black);\n  min-width: 96px;\n  text-align: center;\n}\n.dashv2-qpage-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  color: var(--black);\n  cursor: pointer;\n}\n.dashv2-qpage-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.dashv2-qpage-btn:hover:not(:disabled) {\n  background: var(--hl-gray);\n}\n.dashv2-qpage-btn:disabled {\n  color: var(--subtext);\n  opacity: 0.5;\n  cursor: default;\n}\n.dashv2-qpage-btn:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n\n.dashv2-retrybtn {\n  margin-top: 12px;\n  padding: 6px 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 6px;\n  background: var(--white);\n  color: var(--black);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dashv2-retrybtn:hover {\n  background: var(--hl-gray);\n}\n\n/* ── No-show card ────────────────────────────────────────── */\n.dashv2-nscard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n}\n.dashv2-nshead {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n.dashv2-nscol {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  padding-right: 24px;\n  min-width: 0;\n  /* The labels are nowrap, so a column squeezed by a full header row would\n     otherwise spill its text sideways underneath the adjacent controls rather\n     than clipping inside its own box. */\n  overflow: hidden;\n}\n.dashv2-nscol--client {\n  flex: 0 1 432px;\n}\n.dashv2-nscol--date {\n  flex: 0 0 220px;\n}\n.dashv2-nscol--skill {\n  flex: 0 0 200px;\n}\n/* A real basis, not 0: with basis 0 this column takes only *surplus* space, so\n   on a full header row (the missing-timesheet card carries a \"Shift details\"\n   button as well as the chevron) it collapsed to zero width and its label\n   overflowed. Shrinking now comes out of the wide client column instead. */\n.dashv2-nscol--loc {\n  flex: 1 1 140px;\n}\n.dashv2-nslabel {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n  margin: 0;\n  white-space: nowrap;\n}\n.dashv2-nsvalue {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n.dashv2-nsexpand {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  color: var(--black);\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n.dashv2-nsexpand svg {\n  width: 24px;\n  height: 24px;\n}\n/* NOTE: `.dashv2-nsdetail` — the outlined \"Shift details\" text button — is gone.\n   It existed only because the Missing Timesheet chevron was spent on collapsing\n   the card's own rows, so the drill-in needed a second, unmistakably different\n   control (GRAVY-10297). GRAVY-10318 removed that collapse, freeing the chevron\n   to be the drill-in itself, exactly as No Show and Needs Approval already do. */\n\n.dashv2-nsexpand:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n/* Only when the row has no shift to open (a job with no shift rows), so the\n   control reads as unavailable rather than silently doing nothing. */\n.dashv2-nsexpand:disabled {\n  color: var(--subtext);\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* A grid header and its worker rows must share ONE content box, or the tracks\n   are the same widths at different origins and every column is off by a\n   constant. The rows carry `padding: 16px` — the inset that makes the pink block\n   read as a block — and the header carried none, so both cards' columns sat\n   exactly 16px left of the fields beneath them (GRAVY-10317 / 10318).\n\n   Horizontal only: the header's vertical spacing is the card's, not the row's. */\n.dashv2-nshead.dashv2-nsgrid,\n.dashv2-nshead.dashv2-tsgrid {\n  padding: 0 16px;\n}\n\n/* Worker rows */\n.dashv2-nsworkers {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.dashv2-nsrow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  width: 100%;\n  background: rgba(252, 233, 230, 0.5);\n}\n.dashv2-nsrow:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.dashv2-nsrow:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.dashv2-nsuser {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 363px;\n  min-width: 0;\n}\n.dashv2-avatar {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: var(--hl-gray);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--subtext);\n}\n.dashv2-avatar img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.dashv2-nsname {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashv2-nsfield {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n  padding-right: 16px;\n}\n/* 120px fitted \"No show\" exactly. The unresolved states carry longer labels\n   (\"Awaiting confirmation\"), which wrapped inside a fixed-height 24px pill and\n   spilled out of it (GRAVY-10302). Sized to the longest label instead. */\n.dashv2-nsfield--status {\n  flex: 0 0 190px;\n}\n.dashv2-nsfield--grow {\n  flex: 1 1 0;\n}\n.dashv2-nsbadge {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: #c10000;\n  color: #fff4f3;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  width: fit-content;\n  margin-top: 4px;\n  /* The pill is a fixed 24px tall, so it must never wrap — a wrapped label\n     renders outside its own background. */\n  white-space: nowrap;\n  /* …but `nowrap` + `fit-content` also means it does not shrink, and a grid\n     track does. At a 1024px viewport \"Awaiting confirmation\" rendered 163px\n     wide in a 118px cell and painted 25px OVER the \"Marked by\" column beside\n     it. This is the hard guarantee that it can never leave its own cell,\n     whatever the width; the media query below is what stops it needing to. */\n  max-width: 100%;\n  overflow: hidden;\n}\n/* Only a CONFIRMED absence keeps the solid red treatment. Unresolved\n   attendance alerts are risk, not fact, so they read as amber warnings — the\n   colour has to carry the same distinction the label does (GRAVY-10302). */\n.dashv2-nsbadge.state-awaiting_confirmation,\n.dashv2-nsbadge.state-backfill_requested,\n.dashv2-nsbadge.state-escalated {\n  background: var(--hl-yellow);\n  color: var(--text-yellow);\n}\n.dashv2-nsfield-val {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Missing-timesheet worker row (reuses no-show card + rows) ────────── */\n/* ── No Show: ONE shared column grid (GRAVY-10317) ───────── */\n/* The header and the worker rows used to size themselves independently — the\n   header on flex bases 432/220/200/140, the rows on 363/190/grow — so Status,\n   Marked by and the timestamp did not sit under the headings they belong to.\n   Both now use this single definition, which makes the alignment structural\n   instead of two sets of numbers kept in step by hand.\n\n   Scoped to the No Show card rather than applied to `.dashv2-nshead`, which\n   Missing Timesheet also uses — but its rows are finer-grained than its header\n   (four timesheet columns under two headings), so it needs its own track list\n   and spanning header cells. See `.dashv2-tsgrid`.\n\n   Declared AFTER `.dashv2-nshead` / `.dashv2-nsrow` so `display: grid` wins over\n   their `display: flex` at equal specificity. `flex` on the children is inert\n   inside a grid, so those rules need no unpicking — only the manual\n   `padding-right`, which `gap` replaces. */\n.dashv2-nsgrid {\n  display: grid;\n  grid-template-columns:\n    minmax(0, 2.1fr) minmax(0, 1.25fr) minmax(0, 1.15fr)\n    minmax(0, 1fr) 40px;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n.dashv2-nsgrid .dashv2-nscol,\n.dashv2-nsgrid .dashv2-nsfield,\n.dashv2-nsgrid .dashv2-nsuser {\n  padding-right: 0;\n  min-width: 0;\n}\n\n/* The drill-in. Right-facing and STAYS right-facing: it opens the shift, it\n   does not expand anything (the rows are always shown). */\n.dashv2-nsdrill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--subtext);\n  cursor: pointer;\n}\n.dashv2-nsdrill:hover {\n  background: var(--surface);\n  color: var(--black);\n}\n.dashv2-nsdrill svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-nsdrill:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n.dashv2-nsdrill:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* Call the worker. Same affordance as the Missing Timesheet contact link; the\n   cell is always present so a worker with no authorized number cannot pull the\n   other columns out of alignment. */\n.dashv2-nsaction {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n}\n.dashv2-nsprofile,\n.dashv2-nscall {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  color: var(--green);\n}\n.dashv2-nscall:hover {\n  background: rgba(255, 255, 255, 0.7);\n}\n.dashv2-nsprofile svg,\n.dashv2-nscall svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-nscall:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n\n/* ── Missing Timesheet: ONE shared column grid (GRAVY-10318) ─────────────\n   The header sized itself on the flex bases 432/220/200/140 and the rows on\n   363/160/four-equal-columns plus a `margin-left: auto` action group, so the\n   timesheet columns did not sit under the headings above them and, squeezed,\n   ran into each other.\n\n   The worker row is FINER-GRAINED than the header — Skill heads two time\n   columns, Location heads two more — so the tracks below are the row's, and the\n   header cells span them. That is why this cannot be `.dashv2-nsgrid`: No Show's\n   header maps one-to-one onto its rows.\n\n   Declared AFTER `.dashv2-nshead` / `.dashv2-nsrow` so `display: grid` wins over\n   their `display: flex` at equal specificity. The children's `flex` rules are\n   inert inside a grid, so they need no unpicking — only the manual\n   `padding-right`, which `gap` replaces.\n\n   The time tracks have REAL minimums (not `minmax(0, …)`): their labels are\n   `nowrap`, so a track allowed to collapse below its label width is exactly how\n   \"Check-in\" and \"Check-out\" merged. The minimums are sized to the longest\n   label in each. */\n.dashv2-tsgrid {\n  display: grid;\n  grid-template-columns:\n    minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(76px, 0.7fr) minmax(76px, 0.7fr)\n    minmax(56px, 0.5fr) minmax(56px, 0.5fr) 40px 40px;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n.dashv2-tsgrid .dashv2-nscol,\n.dashv2-tsgrid .dashv2-nsfield,\n.dashv2-tsgrid .dashv2-nsuser,\n.dashv2-tsgrid .dashv2-tscol {\n  padding-right: 0;\n  min-width: 0;\n}\n/* The header's four cells over the row's eight tracks. Placed explicitly rather\n   than left to auto-placement, so a spanning cell cannot shunt the ones after\n   it. */\n.dashv2-tsgrid > .dashv2-nscol--date {\n  grid-column: 1;\n}\n.dashv2-tsgrid > .dashv2-nscol--client {\n  grid-column: 2;\n}\n.dashv2-tsgrid > .dashv2-nscol--skill {\n  grid-column: 3 / span 2;\n}\n.dashv2-tsgrid > .dashv2-nscol--loc {\n  grid-column: 5 / span 2;\n}\n/* Over the two row actions, hard right — the same place the call icon sits, so\n   the card has one action rail rather than two. */\n.dashv2-tsgrid > .dashv2-nsdrill {\n  grid-column: 7 / span 2;\n  justify-self: end;\n}\n.dashv2-tscol {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  align-items: flex-start;\n}\n.dashv2-tscol .dashv2-nslabel {\n  white-space: nowrap;\n}\n.dashv2-tscol-val {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--red);\n  margin: 0;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.dashv2-tscol-val.has-data {\n  color: var(--black);\n}\n\n/* ── Queue cards below the width they were drawn for ─────────────────────\n *\n * The card grids are proportional (`fr`), so on a narrow window every track\n * shrinks together — and the COLUMN LABELS are `nowrap`, so past a point they\n * clip instead. At a 1024px viewport the app shell leaves 704px, which gives No\n * Show's fourth track ~100px while \"Date & time marked\" needs 125: the heading\n * for a column becomes unreadable, which is worse than any value being\n * ellipsised, because a value carries a `title` and a label does not.\n *\n * Below 1280px the labels are allowed to WRAP. Nothing moves, nothing is hidden,\n * and no track has to grow — a two-line heading simply takes the height it\n * needs. `nowrap` stays in force at the widths the design was transcribed from,\n * where it is doing its real job: stopping a squeezed label spilling sideways\n * underneath the control beside it.\n *\n * The values keep ellipsising as before; `.dashv2-nsvalue` and\n * `.dashv2-nsfield-val` already carry `text-overflow` and a `title`. */\n/* ── ≤1439: the narrow-width design ──────────────────────── */\n/* Figma `Admin-Dashboard x 1024` (GravyWork 2.0 Baseline, 39124:32563) is the\n   spec for 1439px and below; what shipped is the 1440+ layout. Its variable\n   modes say so explicitly — `screen/screen-width: 1024`, `show-hide/hamburger\n   menu: true` — so this is a designed breakpoint, not a one-off artboard.\n   Full extract: gravy-docs `dashboard-v2/docs/figma-1024-breakpoint-spec.md`.\n\n   The design's answer to the squeeze is to DROP LABELS TO ICONS rather than\n   shrink type, which is what the earlier 1279 layer below does. Measured from\n   the frame:\n\n     Calendar tab   125px = 16 + 20 + 12 + 61(label) + 16   (keeps its label)\n     queue tabs      84px = 16 + 20 + 12 + 20(badge) + 16   (icon + badge only)\n     summary pill    44px = 12 + 20 + 12                    (icon only)\n     filter toggle   36px square                            (icon only)\n\n   Hidden VISUALLY, never `display: none`: these are the accessible names of the\n   controls, and a tab that announces only \"12\" is worse than a cramped one. */\n@media (max-width: 1439px) {\n  /* The ACTIVE tab always shows its name (GRAVY-10332). Compacting every tab\n     left the green underline as the only cue to which queue you were in, which\n     at the narrowest supported width is where you can least afford to guess.\n     Inactive queue tabs stay icon + badge, so only one label is expanded. */\n  .dashv2-tab:not(.is-labelled):not(.is-active) .dashv2-tab-label,\n  .dashv2-pill-text,\n  .dashv2-showbtn-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    border: 0;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    white-space: nowrap;\n  }\n\n  /* Anchor the hidden span to its own button rather than to whatever ancestor\n     happens to be positioned. */\n  .dashv2-tab,\n  .dashv2-summary-pill,\n  .dashv2-showbtn--compact {\n    position: relative;\n  }\n\n  /* An absolutely-positioned child is out of flex flow, so `gap` no longer has\n     two items to sit between and the padding alone sets the width. The active\n     chip's separator and X have no room beside a bare icon — the fill and\n     border already carry the pressed state. */\n  .dashv2-summary-pill .dashv2-pill-sep,\n  .dashv2-summary-pill .dashv2-pill-x {\n    display: none;\n  }\n  /* 36 SQUARE. Height matters as much as width and was missed first time\n     round: the base rule is 32px tall, so setting only the width left a 36×32\n     control against the frame's 36×36. */\n  /* Scoped to `--compact` — the Calendar's control, the only one the frame\n     draws as a 36px square (GRAVY-10332).\n     \n     This rule was unscoped, so it also hit the action queues' Show/Hide button,\n     whose label is NOT wrapped for hiding — a 36px box around the word \"Show\",\n     which read as a broken control. A width can only be forced onto a button\n     whose text can get out of the way. */\n  .dashv2-showbtn--compact {\n    padding: 0;\n    width: 36px;\n    height: 36px;\n    justify-content: center;\n  }\n\n  /* Pin the two icon-only controls to the frame's own numbers. Both need an\n     explicit width: the boxes are auto-sized from padding, so the 1px border\n     lands OUTSIDE the 44 the design specifies (Figma strokes are centred and\n     do not grow an auto-layout frame). With `box-sizing: border-box` set at the\n     top of this file, a stated width absorbs it. */\n  .dashv2-summary-pill {\n    width: 44px;\n    /* The frame's pills are `h-full` inside a 36px control row — the same\n       height as the funnel beside them, so the row reads as one band. */\n    height: 36px;\n    justify-content: center;\n  }\n  /* 84px tab = 16 + 20 + 12 + 20 + 16. The badge is 20/11px at this width,\n     against 24/12px at 1440+.\n     \n     The frame draws the badge as a fixed `size-[20px]` circle. Ours keeps\n     `min-width` instead so a three-digit count grows rather than clipping — a\n     count badge that hides its own digits is worse than one pixel of drift.\n     The horizontal padding is 2px so that for one- and two-digit counts the\n     min-width still wins under any font and the tab lands on exactly 84: with\n     4px it did not, because Manrope's digits are wider than the fallback this\n     was first measured against, and \"55\" pushed the badge to 21px. */\n  .dashv2-tab-badge {\n    min-width: 20px;\n    height: 20px;\n    padding: 4px 2px;\n    font-size: 11px;\n  }\n  /* The active-filter count is not a label — it is the only thing saying a\n     collapsed bar still has filters in force, so it survives the collapse and\n     sits on the icon. */\n  .dashv2-showbtn--compact .dashv2-qfcount {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n  }\n}\n\n@media (max-width: 1279px) {\n  /* The No Show status pill carries the longest label on the card\n     (\"Awaiting confirmation\"). Give its track a real minimum — the same remedy\n     GRAVY-10318 used for the timesheet columns — and take the pill down to the\n     12px the prototype's own compact treatment uses, so it FITS rather than\n     being clipped by the rule above. A tighter gap pays for the minimum. */\n  .dashv2-nsgrid {\n    grid-template-columns:\n      minmax(0, 1.9fr) minmax(140px, 1.35fr) minmax(0, 1.1fr) minmax(0, 1fr)\n      40px;\n    gap: 12px;\n  }\n  .dashv2-nsbadge {\n    font-size: 12px;\n    padding: 2px 6px;\n  }\n\n  /* `.dashv2-nscol` carries a legacy `padding-right: 24px` from when these were\n     flex columns. `.dashv2-nsgrid`/`.dashv2-tsgrid` reset it — `gap` does that\n     job now — but the Needs Approval row is still a flex row, so it kept it. On\n     a 65px column that leaves 41px of content, which is why \"Location\" broke\n     mid-word into \"Locati / on\" once wrapping was allowed. The row's own `gap`\n     already provides the separation. */\n  .dashv2-narow .dashv2-nscol {\n    padding-right: 0;\n  }\n\n  .dashv2-nslabel {\n    white-space: normal;\n    /* `normal` alone is not enough: a single long word has no break\n       opportunity, so \"Location\" still overflowed and clipped to \"Loc\".\n       `break-word` rather than `anywhere` — it breaks a word only when it\n       would otherwise overflow, and leaves min-content sizing alone. */\n    overflow-wrap: break-word;\n  }\n  /* The Missing Timesheet card is the densest thing on the page — eight tracks,\n     four of them with real minimums sized to their `nowrap` labels\n     (GRAVY-10318). Those minimums plus the gaps consume 456 of the 672px a\n     1024px viewport leaves, so the worker's NAME was squeezed to 39px: unusable,\n     and the one column an admin actually reads.\n\n     Letting these labels wrap too releases their floors, and a tighter gap\n     releases more. Nothing is hidden and no column is dropped — the grid simply\n     stops reserving width for text that is allowed to take a second line. Above\n     1280px none of this applies and the card is exactly as transcribed. */\n  .dashv2-tsgrid {\n    grid-template-columns:\n      minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(52px, 0.7fr) minmax(52px, 0.7fr)\n      minmax(44px, 0.5fr) minmax(44px, 0.5fr) 36px 36px;\n    gap: 10px;\n  }\n  .dashv2-tsedit,\n  .dashv2-tsedit-btn,\n  .dashv2-nsaction,\n  .dashv2-nscall {\n    width: 36px;\n  }\n}\n\n/* ── Needs-approval row (single row per shift, reuses card container) ─── */\n.dashv2-narow {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n/* `0 1`, not `0 0`. The basis is still the designed width, so nothing moves at\n   the widths this row was drawn for — but the columns may now give ground when\n   there is less room than they want. With `0 0` they could not: 220 + 330 + 200\n   plus gaps and the chevron needs ~920px, and a 1024px viewport leaves the\n   dashboard 670, so the row overflowed its own card by 252px. `min-width: 0` is\n   what actually lets a flex item shrink below its content — without it the\n   nowrap value inside sets an implicit floor and the shrink never happens. */\n.dashv2-nacol--date {\n  flex: 0 1 220px;\n  min-width: 0;\n}\n.dashv2-nacol--client {\n  flex: 0 1 330px;\n  min-width: 0;\n}\n.dashv2-nacol--skill {\n  flex: 0 1 200px;\n  min-width: 0;\n}\n/* Real bases, not 0 — the same trap `.dashv2-nscol--loc` already documents on\n   the No Show card. With `flex: 1 1 0` these two take only SURPLUS space, and\n   once the row is over-subscribed there is none: at a 1024px viewport they\n   collapsed to nothing, so Location rendered no value at all and the hired\n   fraction read \"12/\" instead of \"12/15\" — the one number the row exists for.\n\n   Given a basis they shrink in proportion with their neighbours instead, which\n   is what the other three columns already do.\n\n   `flex-grow` stays at 1 deliberately. These two are the columns that absorb\n   the row's surplus, so dropping to `0 1` fixed the narrow case but pulled them\n   in from 246px to 120/90 on a wide screen and left a gap before the chevron.\n   Grow restores that; the basis only decides how the shrink is shared. The two\n   bases are EQUAL so the wide layout is untouched to the pixel — equal basis\n   plus equal grow gives the equal widths `1 1 0` produced — while still giving\n   each column something to shrink from. */\n.dashv2-nacol--loc {\n  flex: 1 1 105px;\n  min-width: 0;\n}\n.dashv2-nacol--fraction {\n  flex: 1 1 105px;\n  min-width: 0;\n}\n.dashv2-nafraction-val {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  margin: 0;\n}\n/* Sub-states are visually distinguished by colour (the Figma mock used one\n   colour for all three; the AC requires distinction). */\n.dashv2-nafraction-val.state-hired {\n  color: var(--text-green);\n}\n.dashv2-nafraction-val.state-for_hired {\n  color: var(--text-yellow);\n}\n.dashv2-nafraction-val.state-for_approval {\n  color: var(--blue);\n}\n\n/* ── Shift Detail side panel ─────────────────────────────── */\n\n/* The global app chrome (AppFrameV2) fixes its navbar at top: 0 with\n   z-index: 3000 — far above this panel's 60. A panel at top: 0 therefore had\n   its first 49px painted over: the 24px of padding plus the header row put the\n   50px logo at y=24-74 (top half covered, reading as a clipped empty circle)\n   and the 24px close button at y=24-48, entirely behind the navbar and so\n   invisible. Both halves of GRAVY-10292 were this one offset.\n\n   Docking below the navbar fixes it without a z-index war: the panel no longer\n   intersects the global header, so it cannot be covered by it. --navbar-h is\n   declared with the other tokens at the top of this file. */\n/* Three rows: a fixed header, a body that scrolls, a fixed footer\n   (GRAVY-10328). The panel itself no longer scrolls — it is the frame.\n\n   This replaces `position: sticky` on the header. Sticky pinned the header\n   correctly, but a sticky FOOTER on the same scrollport would have overlapped\n   the last roster row, and the ticket is explicit that the actions must not\n   obscure panel content. With the body as the only scroll container, the header\n   and footer take their own space by construction and cannot cover anything. */\n.dashv2-panel {\n  position: fixed;\n  top: var(--navbar-h);\n  right: 0;\n  bottom: 0;\n  width: 330px;\n  background: var(--white);\n  border-left: 1px solid var(--stroke-gray);\n  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.06);\n  /* The frame never scrolls; .dashv2-panel-body does. */\n  overflow: hidden;\n  z-index: 60;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Manrope', sans-serif;\n  color: var(--black);\n}\n/* The one scrollport. `min-height: 0` is what actually lets it scroll: a flex\n   item's default `min-height: auto` refuses to shrink below its content, so\n   without it the body grows past the panel and pushes the footer off screen. */\n.dashv2-panel-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n/* AppFrameV2 only fixes the navbar at @smallDesktop; below that it sits in the\n   normal grid flow, so a fixed offset would leave a gap at the top. */\n@media (max-width: 991px) {\n  .dashv2-panel {\n    top: 0;\n  }\n}\n.dashv2-panel-overlay {\n  position: fixed;\n  inset: 0;\n  background: transparent;\n  z-index: 55;\n}\n\n/* Header */\n/* The band that stays put while the body scrolls: the Needs attention badge\n   and the close control on one row, then the skill heading. It is a fixed flex\n   row of the panel rather than a sticky box, so scrolled content passes beneath\n   it and can never show above it (see .dashv2-panel). */\n.dashv2-panel-header {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 24px 24px 12px;\n  background: var(--white);\n}\n/* The badge sits left, the X right, whether or not the badge is there — the\n   empty <span> placeholder is what holds the X in place on a non-critical\n   shift. */\n.dashv2-panel-headrow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n/* \"Needs attention\" — white on red, the calendar card's Critical band said in\n   words (GRAVY-10328). Never rendered for a non-critical shift. */\n.dashv2-panel-critical {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: var(--red);\n  color: var(--white);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n  width: fit-content;\n}\n/* The sticky footer: View job, and View QR for QR jobs. Outside the scrollport\n   by construction, so it takes its own space instead of covering the last row\n   of content. Buttons stack full width, matching the design. */\n.dashv2-panel-footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--stroke-gray);\n  background: var(--white);\n}\n.dashv2-panel-headmain {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1 1 0;\n  min-width: 0;\n}\n.dashv2-panel-logo {\n  width: 50px;\n  height: 50px;\n  border-radius: 100px;\n  overflow: hidden;\n  background: var(--white);\n  border: 1px solid var(--hl-gray);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  /* Initials fallback, shown when the client has no logo or the image fails.\n     An empty circle reads as a broken panel; initials read as a client. */\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--subtext);\n}\n.dashv2-panel-logo.is-fallback {\n  background: var(--hl-gray);\n}\n.dashv2-panel-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.dashv2-panel-title {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.4;\n  margin: 0;\n}\n.dashv2-panel-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  color: var(--black);\n  flex-shrink: 0;\n}\n.dashv2-panel-close:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n/* An INVITE's state — Invited, Declined, or whatever else the server reports.\n   Invited reads as green (the offer is live), Declined as purple with the\n   design's info glyph. An unrecognised status falls through to the neutral base\n   rather than being recoloured as something it is not. */\n.dashv2-panel-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: var(--hl-gray);\n  color: var(--subtext);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  width: fit-content;\n}\n.dashv2-panel-status svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.dashv2-panel-status.is-invited {\n  background: var(--hl-green);\n  color: var(--text-green);\n}\n/* Indigo, straight from the design — the palette above has no purple, and a\n   declined invite is deliberately not red: it is information, not a failure. */\n.dashv2-panel-status.is-declined {\n  background: #eceafe;\n  color: #4f46e5;\n}\n/* The shift's lifecycle status, moved out of the header into the tag block. */\n.dashv2-panel-lifecycle {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: var(--blue-bg);\n  color: var(--blue);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  width: fit-content;\n}\n/* An empty Invites / Hired / Recent activity section. The section still renders\n   its heading and count — this line is what makes zero read as \"nobody\", not as\n   a block that failed to load. */\n.dashv2-panel-empty {\n  margin: 0;\n  padding: 8px 0 16px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n.dashv2-panel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  background: var(--white);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4;\n  text-decoration: none;\n}\n.dashv2-panel-btn svg {\n  width: 24px;\n  height: 24px;\n}\n/* Full width, stacked — the footer is a column, so `flex: 1 1 0` here would\n   stretch the button vertically instead of across. */\n.dashv2-panel-btn.is-primary {\n  width: 100%;\n  border: 1px solid var(--green);\n  color: var(--text-green);\n  font-weight: 600;\n}\n.dashv2-panel-btn.is-secondary {\n  width: 100%;\n  border: 1px solid var(--stroke-gray);\n  color: var(--black);\n  font-weight: 400;\n}\n\n/* Gate + classification row */\n.dashv2-panel-gaterow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.dashv2-panel-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-panel-chip svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Job details */\n.dashv2-panel-details {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.dashv2-panel-jobblock {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.dashv2-panel-jobid {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--text-green);\n  text-decoration: none;\n}\n.dashv2-panel-jobid svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-panel-shiftinfo {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.dashv2-panel-hours {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-panel-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 100px;\n  background: var(--black);\n  flex-shrink: 0;\n}\n.dashv2-panel-role {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n  margin: 0;\n}\n.dashv2-panel-address {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--subtext);\n  margin: 0;\n}\n.dashv2-panel-supervisor {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.dashv2-panel-suptitle {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-panel-supname {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-panel-supphone {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n.dashv2-panel-divider {\n  height: 1px;\n  width: 100%;\n  background: var(--stroke-gray);\n}\n\n/* Workers */\n/* No .dashv2-panel-fillrow: the \"N of M hired · X% filled\" summary it styled is\n   removed (GRAVY-10328). The Invites and Hired headings carry the same counts,\n   and the approved design has neither line. */\n.dashv2-panel-worker {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding-bottom: 16px;\n}\n.dashv2-panel-worker .dashv2-avatar {\n  width: 44px;\n  height: 44px;\n}\n.dashv2-panel-workermeta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1 1 0;\n  min-width: 0;\n}\n.dashv2-panel-workername {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashv2-panel-workertags {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n/* The Quality Gate verdict, as the approved design draws it: a boxed arrow and\n   nothing else. The numeric score moved to the tooltip — it decides nothing\n   (GRAVY-10313), and printing it beside an arrow it does not derive from is\n   what made the two look like they should agree. */\n.dashv2-panel-dep {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  flex-shrink: 0;\n  color: var(--text-green);\n}\n.dashv2-panel-dep svg {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.5;\n}\n/* Below the gate, whatever the score says. `is-below` is the hired row's tier;\n   `is-below-gate` is set from the verdict itself, so an invite whose tier is a\n   raw policy name still colours correctly. */\n.dashv2-panel-dep.is-below,\n.dashv2-panel-dep.is-below-gate {\n  color: var(--red);\n}\n/* No .dashv2-panel-chip.is-off: an \"off\" gate no longer renders a muted chip.\n   The updated design rules out a \"Not enabled\" tag entirely — the tag is\n   absent, so there is nothing left to mute. */\n/* The roster spans every post-shift status since GRAVY-10326, so this chip names\n   the worker's state instead of always reading \"Hired\". Blue stays the default —\n   the states Ops acts on are tinted below, and everything else reads as neutral\n   information rather than competing with the Dependability warning beside it. */\n.dashv2-panel-hiredtag {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: var(--blue-bg);\n  color: var(--blue);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n/* Finished and settled — the common post-shift states. */\n.dashv2-panel-hiredtag.is-completed,\n.dashv2-panel-hiredtag.is-approved,\n.dashv2-panel-hiredtag.is-paid {\n  background: var(--hl-green);\n  color: var(--text-green);\n}\n/* Needs someone to look at it. */\n.dashv2-panel-hiredtag.is-rejected {\n  background: var(--hl-red);\n  color: var(--red);\n}\n.dashv2-panel-hiredtag.is-expired {\n  background: var(--hl-gray);\n  color: var(--subtext);\n}\n/* No .dashv2-panel-cta: the \"Increase pay rate\" button it styled is removed\n   for this release (GRAVY-10294). The worker list ends on the last\n   .dashv2-panel-worker, whose own 16px padding-bottom closes the block, so\n   dropping the button leaves no empty container or collapsed gap behind. */\n\n/* Recent activity */\n.dashv2-panel-actitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n/* A button rather than the styled span this shipped as, so it is clickable,\n   focusable and reachable by keyboard — reset to keep the Figma's plain-link\n   appearance (GRAVY-10294). */\n.dashv2-panel-viewall {\n  padding: 0;\n  border: 0;\n  background: none;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--text-green);\n  cursor: pointer;\n}\n.dashv2-panel-viewall:focus-visible {\n  outline: 2px solid var(--green);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n.dashv2-panel-actlist {\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n}\n.dashv2-panel-actitem {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-bottom: 16px;\n}\n.dashv2-panel-actrow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.dashv2-panel-actrow .dashv2-avatar {\n  width: 32px;\n  height: 32px;\n  font-size: 12px;\n}\n.dashv2-panel-acttext {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.4;\n  flex: 1 1 0;\n  min-width: 0;\n}\n.dashv2-panel-acttext b {\n  font-weight: 700;\n}\n.dashv2-panel-actmeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n.dashv2-panel-loading {\n  padding: 48px 0;\n  text-align: center;\n  color: var(--subtext);\n  font-size: 14px;\n}\n\n/* ── Recent activity modal (\"View all\") ──────────────────── */\n/* Sits above the Shift Detail panel (z-index 60) and its click-catching\n   overlay (55), so the panel and calendar stay on screen, dimmed, and a click\n   on this backdrop cannot fall through and close the panel underneath\n   (GRAVY-10294). Above the global navbar (3000) too — unlike the panel, this\n   is centred on the viewport and would otherwise be clipped by it. */\n.dashv2-actmodal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(28, 28, 28, 0.45);\n  z-index: 3100;\n}\n.dashv2-actmodal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  width: min(520px, calc(100vw - 32px));\n  /* The list scrolls inside the body; the header and footer never leave. */\n  max-height: min(640px, calc(100vh - 64px));\n  border-radius: 12px;\n  background: var(--white);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\n  z-index: 3101;\n  font-family: 'Manrope', sans-serif;\n  color: var(--black);\n}\n.dashv2-actmodal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px 24px 16px;\n}\n.dashv2-actmodal-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n.dashv2-actmodal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 0 24px;\n}\n.dashv2-actmodal-state {\n  padding: 32px 0;\n  text-align: center;\n  color: var(--subtext);\n  font-size: 14px;\n}\n.dashv2-actmodal-more {\n  width: 100%;\n  margin-bottom: 16px;\n  padding: 8px 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  color: var(--text-green);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  cursor: pointer;\n}\n.dashv2-actmodal-more:disabled {\n  color: var(--subtext);\n  cursor: default;\n}\n.dashv2-actmodal-foot {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px 24px;\n  border-top: 1px solid var(--stroke-gray);\n}\n.dashv2-actmodal-back {\n  padding: 8px 24px;\n  border: 1px solid var(--green);\n  border-radius: 8px;\n  background: var(--white);\n  color: var(--text-green);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  cursor: pointer;\n}\n.dashv2-actmodal-back:hover {\n  background: var(--hl-green);\n}\n\n/* Tab placeholder (stub queues) */\n.dashv2-stub {\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--subtext);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.dashv2-retry {\n  margin-top: 16px;\n  padding: 8px 20px;\n  border: 1px solid var(--border, #d0d5dd);\n  border-radius: 8px;\n  background: var(--surface, #fff);\n  color: var(--text, #101828);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dashv2-retry:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* ── Action-queue filter bar (GRAVY-10315) ───────────────── */\n/* The three queues use the SHARED `.dashv2-fbar` / `.dashv2-fseg` bar defined\n   with the Calendar bar above (GRAVY-10305) — Figma node 38995:64197 is the\n   same horizontal segmented row, so it is the same CSS rather than a parallel\n   copy that can drift. Only the Show/Hide pill's count badge and the Date range\n   body are queue-specific.\n\n   The old `.dashv2-qfpopover` and its checkbox/date rules are gone with the\n   popover they styled; keeping dead selectors around is how the wrong control\n   gets resurrected. */\n.dashv2-qfcount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  padding: 0 6px;\n  border-radius: 100px;\n  background: var(--green);\n  color: var(--white);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Date range body inside a segment menu. */\n.dashv2-fseg-dates {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  min-width: 240px;\n}\n.dashv2-fseg-date {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--black);\n}\n.dashv2-fseg-date input {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 4px 8px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n}\n.dashv2-fseg-date:focus-within {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* ── ≤1439: Shift Detail rail ────────────────────────────── */\n/* Placed at the END of the file on purpose. These override `.dashv2-panel` and\n   the roster row, which are declared ~200 lines above; an equal-specificity\n   rule in the earlier ≤1439 block loses on source order and silently does\n   nothing (it did — the panel measured 330 at every width until this moved).\n\n   Figma `shift-info` (39124:32862): the rail is 280 wide with 24px padding, so\n   its content box is 232 — against 330/282 at 1440+. The roster row is what\n   makes 232 work, and the frame gives its geometry directly: avatar 32 at x=0,\n   name at x=44 (so a 12px gap), name 20px tall = 14px at line-height 1.4,\n   phone glyph 20px at x=212. */\n@media (max-width: 1439px) {\n  .dashv2-panel {\n    width: 280px;\n  }\n  .dashv2-panel-worker .dashv2-avatar {\n    width: 32px;\n    height: 32px;\n  }\n  .dashv2-panel-workername {\n    font-size: 14px;\n  }\n}\n\n/* ── \"Ops on duty today\" strip ───────────────────────────── */\n/* Figma `ops-sched` (39124:33453), measured off the frame: the card is 697×86\n   inside a 24px gutter; the title sits at (16,12) and the roster row at (16,50),\n   so the card padding is 16 / 12 and the two rows are 16 apart. Entries are 24px\n   tall and 16px apart (x=0/212/448 for widths 196/220/210). Within an entry: an\n   8px dot, the name 16px away from it, the hours 8px after the name, and a 24px\n   call button 16px after that.\n\n   Rendered only when the strip has entries — see OpsOnDuty.tsx on why that is\n   the branch that currently runs. */\n.dashv2-ops {\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n  padding: 12px 16px;\n  margin-bottom: 24px;\n}\n.dashv2-ops-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-ops-title svg {\n  width: 20px;\n  height: 20px;\n}\n.dashv2-ops-list {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 16px 0 0;\n  padding: 0;\n  list-style: none;\n}\n.dashv2-ops-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n}\n.dashv2-ops-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--green);\n  flex: 0 0 auto;\n}\n.dashv2-ops-dot.is-off {\n  background: var(--stroke-gray);\n}\n/* The name sits 16px from the dot in the frame (dot 8 at x=0, name at x=16). */\n.dashv2-ops-name {\n  margin-left: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-ops-hours {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n.dashv2-ops-call {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  margin-left: 8px;\n  border-radius: 50%;\n  background: var(--green);\n  color: var(--white);\n  flex: 0 0 auto;\n}\n.dashv2-ops-call svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* The strip belongs to the ≤1439 design; at 1440+ the dashboard has no such\n   band, so it stays out of the way rather than being shown at a width that\n   never specified it. */\n@media (min-width: 1440px) {\n  .dashv2-ops {\n    display: none;\n  }\n}\n\n/* ── Shift Detail: labelled info block (GRAVY-10328) ─────── */\n/* Figma 38851:108868. Client / Address / Shift supervisor became labelled\n   fields — 16px label over a 14px value, 8px apart, blocks 16px apart — and\n   collapse together behind a centred \"Hide info\" toggle. */\n.dashv2-panel-infoblock {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n/* REQUIRED, not belt-and-braces. The UA stylesheet's `[hidden] { display: none }`\n   is a bare attribute selector, so the class rule above wins on specificity and\n   the block stays on screen with `hidden` set — \"Hide info\" flipped\n   `aria-expanded` and hid nothing. Any element given `display` by a class needs\n   its own `[hidden]` rule. */\n.dashv2-panel-infoblock[hidden] {\n  display: none;\n}\n.dashv2-panel-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n.dashv2-panel-fieldlabel {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-panel-fieldvalue {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n  overflow-wrap: break-word;\n}\n.dashv2-panel-infotoggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-panel-infotoggle svg {\n  width: 24px;\n  height: 24px;\n  transition: transform 0.12s;\n}\n\n/* ── Day view (GRAVY-10329) ──────────────────────────────── */\n/* Figma `Admin-Dashboard x 1024` — the Today/Week/Day control (39124:32612)\n   and the stacked shift cards (`Item 1`/`Item 3`, 39124:32648 / 32833). */\n.dashv2-navgroup {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n.dashv2-viewtoggle {\n  display: flex;\n  align-items: center;\n  padding: 2px 2px 2px 0;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: #fcfcfc;\n}\n.dashv2-viewtoggle-btn {\n  height: 32px;\n  padding: 8px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--black);\n}\n/* Greyed rather than hidden when it would do nothing — the frame's own\n   treatment, and it keeps the control's width stable. */\n.dashv2-viewtoggle-btn:disabled {\n  color: var(--deactivated);\n  cursor: default;\n}\n.dashv2-viewtoggle-btn.is-active {\n  border-radius: 6px;\n  background: var(--green);\n  color: var(--white);\n  font-weight: 600;\n}\n\n.dashv2-daylist {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 0 24px;\n}\n/* The card's own border and background ARE the priority signal (GRAVY-10335).\n   Filled is the neutral resting state; Critical and At risk tint the whole row,\n   so an admin scanning the day sees the hierarchy without reading a word.\n\n   The two washes are sampled straight from Figma 39391:14056 and are much\n   fainter than --hl-red / --hl-yellow, which are chip fills: at full width a\n   chip tint reads as an error state rather than a priority. They have no token\n   for that reason — a token implies reuse, and these are specific to a\n   full-bleed row. The BORDERS are tokens, and match the week grid's bands. */\n.dashv2-daycard {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 16px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 8px;\n  background: var(--white);\n}\n.dashv2-daycard.is-critical {\n  border-color: var(--stroke-red);\n  background: #fffaf9;\n}\n.dashv2-daycard.is-at_risk {\n  border-color: var(--stroke-yellow);\n  background: #fcfaf3;\n}\n/* `is-filled` and `is-unknown` inherit the neutral card above deliberately —\n   naming them here would invite someone to tint them. */\n.dashv2-daycard-head {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n/* `min-width: 0` is what lets a long client name ellipsise instead of pushing\n   the badge and chevron out of the card. */\n.dashv2-daycard-main {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n.dashv2-daycard-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: var(--black);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dashv2-daycard-lock {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 auto;\n  color: var(--subtext);\n}\n.dashv2-daycard-role,\n.dashv2-daycard-time,\n.dashv2-daycard-loc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dashv2-daycard-role {\n  font-weight: 400;\n  color: var(--black);\n}\n.dashv2-daycard-time {\n  font-weight: 600;\n  color: var(--black);\n}\n.dashv2-daycard-loc {\n  font-weight: 400;\n  color: var(--subtext);\n}\n.dashv2-daycard-badge {\n  flex: 0 0 auto;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--red);\n  color: var(--white);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.dashv2-daycard-open {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: var(--black);\n}\n.dashv2-daycard-open svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* No `.is-alert` variant any more: the tinted, bordered box this styled was the\n   ONLY thing distinguishing an unfilled shift, and it drew Critical and At risk\n   identically (GRAVY-10335). The card carries the state now, and the fraction\n   below is a solid pill coloured by its own rule. */\n.dashv2-daycard-fill {\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n/* A solid pill, white on the state colour — Figma 39391:14056 draws it as the\n   design-system status chip rather than as bare coloured text, which at 14px\n   was too quiet to survive a full-width row. */\n.dashv2-daycard-metric {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  background: var(--hl-gray);\n  color: var(--subtext);\n}\n.dashv2-daycard-metric svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n.dashv2-daycard-metric.is-filled {\n  background: var(--green);\n  color: var(--white);\n}\n/* Nobody hired, and imminent-and-partly-staffed, are both red. `is-empty` is\n   deliberately NOT folded into `is-critical`: an At-risk shift with 0 hired is\n   red too, which is the whole reason the pill has a rule of its own. */\n.dashv2-daycard-metric.is-empty,\n.dashv2-daycard-metric.is-critical {\n  background: var(--red);\n  color: var(--white);\n}\n.dashv2-daycard-metric.is-atrisk {\n  background: var(--sec-yellow);\n  color: var(--white);\n}\n/* `is-unknown` keeps the neutral base above: an older API sending no\n   fill_status must not have a colour invented for it. */\n\n.dashv2-dayempty {\n  padding: 48px 16px;\n  text-align: center;\n  color: var(--subtext);\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n/* ── Shift Detail: Invites / Hired sections (GRAVY-10328) ── */\n/* Figma 39273:35064. A 24px heading row carrying the label and count with a\n   collapse chevron, then the rows. The count sits in the heading so it stays\n   legible while the section is collapsed. */\n.dashv2-panel-section {\n  display: flex;\n  flex-direction: column;\n  margin-top: 16px;\n}\n.dashv2-panel-sectionhead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black);\n}\n.dashv2-panel-sectionhead svg {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 auto;\n  transition: transform 0.12s;\n}\n/* Same `[hidden]` guard the info block needs: a class-set `display` outranks\n   the UA's bare `[hidden]` rule, so the section would collapse its chevron and\n   keep its rows on screen. */\n.dashv2-panel-section > [hidden] {\n  display: none;\n}\n.dashv2-panel-status.is-invited {\n  background: var(--hl-green, #e7f4e6);\n  color: var(--text-green);\n}\n.dashv2-panel-status.is-declined {\n  background: #eee7fc;\n  color: #2d2bd9;\n}\n\n/* The Show/Hide word occupies the same box in both states, so toggling the\n   filter bar cannot resize its own button (GRAVY-10332). Sized in `em` so it\n   tracks the font rather than pinning a pixel measurement of one string. */\n.dashv2-showbtn-word {\n  display: inline-block;\n  min-width: 2.7em;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
